// ─────────────────────────────────────────────────────────────
//  ENGLISH TRANSLATIONS
//  Every key here must exist in tr.js as well.
// ─────────────────────────────────────────────────────────────

const en = {

  /* ── Language ── */
  "lang.tr": "Türkçe",
  "lang.en": "English",
  "lang.label": "Language",

  /* ── Common ── */
  "common.save": "Save",
  "common.cancel": "Cancel",
  "common.confirm": "Confirm",
  "common.close": "Close",
  "common.loading": "Loading...",
  "common.error": "Error",
  "common.success": "Success",
  "common.yes": "Yes",
  "common.no": "No",
  "common.back": "Back",
  "common.filter": "Filter",
  "common.none": "None",
  "common.ok": "OK",
  "common.send": "Send",
  "common.copy": "Copy",
  "common.copied": "Copied",
  "common.share": "Share",
  "common.download": "Download",
  "common.upload": "Upload",
  "common.update": "Update",
  "common.select": "Select",
  "common.required": "Required",
  "common.optional": "Optional",
  "common.or": "or",
  "common.and": "and",

  /* ── App ── */
  "app.name": "Family Planner",
  "app.tagline": "Together with your family, everything is easier",
  "app.developer": "Developed by Sercan YAVUZ.",
  "app.version": "Version",
  "app.feedback": "✉️ Send Feedback",
  "app.description": "Designed for planning together with your family.\nAll data is stored securely in the database.",

  /* ── Auth ── */
  "auth.welcome": "Welcome",
  "auth.privacyPolicy": "Privacy Policy",
  "auth.termsOfService": "Terms of Service",
  "auth.legalLinksLabel": "Legal documents",
  "auth.legalConsentPrefix": "By registering, I confirm that I have read and agree to the",
  "auth.legalConsentAnd": "and",
  "auth.legalConsentSuffix": ".",
  "auth.error.legalConsentRequired": "You must accept the Privacy Policy and Terms of Service to create an account.",
  "auth.loginSub": "Sign in to your family's world",
  "auth.resetSub": "We'll send you a password reset link",
  "auth.login": "Sign In",
  "auth.logout": "Sign Out",
  "auth.register": "✨ Create New Account",
  "auth.createAccount": "Create Account",
  "auth.createAccountSub": "Enter your information to join your family group",
  "auth.forgotPassword": "Forgot password",
  "auth.resetPassword": "Reset Password",  "auth.placeholder.newPassword": "New password",  "auth.placeholder.newPasswordAgain": "New password again",  "auth.error.passwordMin": "Password must be 8-128 characters.",  "auth.error.passwordMismatch": "Passwords do not match.",  "auth.info.passwordResetSuccess": "Your password has been updated. You can sign in with your new password.",
  "auth.sendResetMail": "Send Reset Email",
  "auth.backToLogin": "Back to sign in",
  "auth.diffAccount": "Sign in with a different account",
  "auth.placeholder.loginInfo": "Email, username or phone",
  "auth.placeholder.password": "Password",
  "auth.placeholder.passwordMin": "Password (8-128 characters)",
  "auth.placeholder.name": "First Name",
  "auth.placeholder.surname": "Last Name",
  "auth.placeholder.phone": "Phone: 05XXXXXXXXX",
  "auth.placeholder.username": "Username",
  "auth.placeholder.email": "Email",
  "auth.placeholder.heightCm": "Height (cm)",
  "auth.placeholder.weightKg": "Weight (kg)",
  "auth.placeholder.bloodGroup": "Select blood type",
  "auth.showPassword": "Show password",
  "auth.hidePassword": "Hide password",
  "auth.verifyEmail": "Verify your email",
  "auth.verifyEmailDesc": "You need to verify the email address linked to your account to continue.",
  "auth.verifyEmailInfo1": "We sent the verification link to this address.",
  "auth.verifyCheck": "I verified, Check Now",
  "auth.resendVerification": "Resend verification email",
  "auth.resendVerificationCountdown": "You can resend in {{seconds}} sec",
  "auth.verifyStepInbox": "Open the Family Planner verification email in your inbox.",
  "auth.verifyStepSpam": "If you cannot see it, check Spam, Junk, or Promotions.",
  "auth.verifyStepReturn": "Tap the verification link; the app will continue automatically.",
  "auth.wrongVerificationEmail": "My email address is wrong",
  "auth.newVerificationEmail": "New email address",
  "auth.currentPassword": "Current password",
  "auth.updateEmailAndSend": "Update address and send",
  "auth.info.verificationAddressUpdated": "Your email address was updated and a new verification email was sent.",
  "auth.error.verificationInitialSendFailed": "Your account was created, but the verification email could not be sent right now. Please retry with the button below.",
  "auth.error.verificationEmailUnchanged": "The new email address must be different from your current address. To resend to the same address, use the resend verification email button.",
  "auth.error.verificationEmailChangeUnavailable": "The email update service is currently unavailable. Please try again later.",
  "auth.error.verificationEmailUpdateFailed": "The email address could not be updated.",
  "auth.footer": "Family Planner App · Sercan YAVUZ",

  /* ── Navigation / Page Titles ── */
  "nav.home": "Home",
  "nav.shopping": "Shopping",
  "nav.calendar": "Calendar",
  "nav.finance": "Finance",
  "nav.tasks": "Tasks",
  "nav.sharedExpenses": "Expenses",
  "nav.health": "Health Data",
  "nav.map": "Family Map",
  "nav.children": "Child & Baby Tracker",
  "nav.chat": "Family Chat",
  "nav.documents": "Documents",
  "nav.cooking": "What to Cook Today?",
  "nav.management": "Management",

  "management.adminOnlyToast": "Only family admins can access this section.",
  /* ── SideMenu ── */
  "menu.brand": "Family Planner",
  "menu.brandSub": "Aile Yönetimi",

  /* ── Settings Panel ── */
  "settings.title": "⚙️ Settings",
  "settings.tab.general": "General",
  "settings.tab.notifications": "Notifications",
  "settings.tab.family": "Family",
  "settings.tab.colors": "Colors",
  "settings.tab.privacy": "Privacy",
  "settings.tab.about": "About",

  "settings.theme": "Theme",
  "settings.theme.dark": "🌙 Dark",
  "settings.theme.light": "☀️ Light",
  "settings.theme.hint": "Theme changes are applied instantly.",

  "settings.currency": "Currency",

  "settings.defaultPage": "Default Start Page",
  "settings.defaultPage.hint": "This page opens when you launch the app.",

  "settings.language": "Language / Dil",
  "settings.language.hint": "Change the application language.",

  "settings.notifications.loading": "Loading notification settings...",
  "settings.notifications.loadingHint": "Fetching your last preferences.",
  "settings.notifications.pushStatus": "📱 Device Push Status",
  "settings.notifications.pushUnsupported": "⚠️ This device / browser does not support Web Push. If you're on iPhone, add the app to your Home Screen and open it from there.",
  "settings.notifications.pushActive": "Push notifications active",
  "settings.notifications.pushActiveHint": "You'll receive notifications even when the app is closed.",
  "settings.notifications.pushPassive": "Push notifications inactive",
  "settings.notifications.pushPassiveHint": "You are not receiving notifications when the app is closed.",
  "settings.notifications.pushActivate": "🔔 Activate Push Notifications",
  "settings.notifications.pushActivating": "Activating…",
  "settings.notifications.masterControl": "Master Notification Control",
  "settings.notifications.allNotifications": "All Notifications",
  "settings.notifications.allHint": "Turn all push notifications on or off with a single tap.",
  "settings.notifications.categories": "Category Notifications",
  "settings.notifications.cat.chat": "💬 Chat Notifications",
  "settings.notifications.cat.tasks": "✅ Task Notifications",
  "settings.notifications.cat.calendar": "📅 Calendar Notifications",
  "settings.notifications.cat.health": "❤️ Health / Medication Reminders",
  "settings.notifications.cat.shopping": "🛒 Shopping Notifications",
  "settings.notifications.cat.sharedExpenses": "💸 Shared Expense Notifications",
  "settings.notifications.cat.finance": "💰 Finance Notifications",
  "settings.notifications.cat.documents": "📁 Document Notifications",
  "settings.notifications.cat.documentExpiry": "⏳ Document Expiry Reminders",
  "settings.notifications.cat.familyAnnouncements": "📢 Family Announcements",
  "settings.notifications.cat.birthdays": "🎂 Birthday Notifications",
  "settings.notifications.cat.familyStatus": "📍 Family Status Notifications",
  "settings.notifications.quietHours": "Quiet Hours",
  "settings.notifications.quietHoursToggle": "Enable quiet hours",
  "settings.notifications.quietHoursHint": "Automatic reminders won't be sent during these hours.",
  "settings.notifications.quietStart": "Start",
  "settings.notifications.quietEnd": "End",
  "settings.notifications.autoReminders": "Automatic Reminders",
  "settings.notifications.autoRemindersHint": "These settings are read by the backend automatic reminder engine.",
  "settings.notifications.shoppingReminder": "Pending Shopping Reminders",
  "settings.notifications.shoppingReminderHint": "If there are unpurchased items in the shopping list, you'll be reminded at the selected interval.",
  "settings.notifications.freq.off": "Off",
  "settings.notifications.freq.6hours": "Every 6 hours",
  "settings.notifications.freq.daily": "Once a day",
  "settings.notifications.freq.2days": "Every 2 days",
  "settings.notifications.freq.weekly": "Once a week",
  "settings.notifications.taskReminders": "Task Reminder Times",
  "settings.notifications.task.today": "🔴 Due today",
  "settings.notifications.task.tomorrow": "🟠 1 day before",
  "settings.notifications.task.threeDays": "🟡 3 days before",
  "settings.notifications.calendarReminders": "Calendar Reminders",
  "settings.notifications.calendar.today": "📅 Event day",
  "settings.notifications.calendar.tomorrow": "⏰ 1 day before",
  "settings.notifications.docReminders": "Document Expiry Reminders",
  "settings.notifications.doc.oneDay": "⚠️ 1 day before / expiring today",
  "settings.notifications.doc.sevenDays": "📁 7 days before",
  "settings.notifications.doc.thirtyDays": "📁 30 days before",
  "settings.notifications.healthReminders": "Health Reminders",
  "settings.notifications.financeReminders": "Finance Reminders",
  "settings.notifications.finance.installments": "Installment payments",
  "settings.notifications.finance.subscriptions": "Subscription renewals",
  "settings.notifications.finance.bills": "Bill payments",
  "settings.notifications.finance.savings": "Savings check-ins",
  "settings.notifications.health.appointments": "🏥 Health appointments",
  "settings.notifications.health.medicines": "💊 Medication reminders",
  "settings.notifications.saved": "Notification settings saved ✓",

  "settings.family.rename": "Rename Family",
  "settings.family.renameSuccess": "Family name updated ✓",
  "settings.family.namePlaceholder": "Family name",
  "settings.family.inviteCode": "Family Invite Code",
  "settings.family.appGuideTitle": "App Guide",
  "settings.family.appGuideHint": "Rediscover the main features and quick gestures available from the home screen.",
  "settings.family.startAppGuide": "Start App Guide",
  "settings.family.inviteCodeHint": "Share this code to add new members to your family group.",
  "settings.family.shareInvite": "Share family invite",
  "settings.family.shareText": "invite code to join the family:",
  "settings.family.shareJoinHint": "Enter this code in the \"Join with Code\" section of the Family Planner app to join the family.",
  "settings.family.shareClipboard": "Family invite info copied.",
  "settings.family.copyFailed": "Family code: ",

  "settings.colors.title": "Calendar Colors",
  "settings.colors.hint": "Assign a color to each family member. This color appears in calendar events.",

  "settings.privacy.export": "Export Data",
  "settings.privacy.exportHint": "Download your profile information as a JSON file.",
  "settings.privacy.exportBtn": "📥 Download Data",
  "settings.privacy.deleteLocationHistory": "Delete My Location History",
  "settings.privacy.deleteLocationHistoryHint": "All your location history records on the map page will be permanently deleted from the server. This action cannot be undone.",
  "settings.privacy.deleteLocationHistorySuccess": "Your location history has been successfully deleted.",
  "settings.privacy.deleteLocationHistoryBtn": "Delete My Location History",
  "settings.privacy.deleteAccount": "Delete Account",
  "settings.privacy.deleteHint": "This action cannot be undone. Your personal profile, sessions, notification devices, location history, and files you uploaded are cleaned. Shared family records are preserved.",
  "settings.privacy.deleteBtn": "🗑 Delete Account",
  "settings.privacy.confirmDelete": "Confirm, Delete",
  "settings.privacy.confirmPasswordPlaceholder": "Confirm your password",
  "settings.privacy.deleteSuccess": "Your account has been deleted. Signing you out.",
  "settings.privacy.deleteFailed": "Account could not be deleted. Please try again.",
  "settings.privacy.adminTransferRequired": "You are the only manager in this family. Transfer family management to another member before deleting your account.",
  "settings.privacy.invalidPassword": "Incorrect password.",
  "settings.privacy.passwordRequired": "Enter your password to continue.",
  "settings.privacy.finalDeleteWarning": "Your account will be deleted. Your profile will be anonymized, sessions will be closed, location history and files you uploaded will be cleaned. Shared family records are preserved. This cannot be undone.",

  "settings.about.version": "Version 1.7.1 (22)",
  "settings.about.description": "Designed for planning together with your family.\nAll data is stored securely.",
  "settings.about.feedback": "✉️ Send Feedback",
  "settings.about.feedbackShort": "Send Feedback",
  "settings.about.rateApp": "Rate Us",
  "settings.about.rateError": "The store review page could not be opened. Please try again later.",
  "settings.about.followUs": "CONNECT WITH US",
  "settings.about.website": "Website",
  "settings.about.instagramAria": "Open Aile Yönetimi on Instagram",
  "settings.about.websiteAria": "Open the Aile Yönetimi website",
  "settings.about.linkError": "The link could not be opened. Please try again later.",
  "settings.about.developer": "YAVUZ SOFT ©",

  /* ── Feedback ── */
  "feedback.navTitle": "Feedback",
  "feedback.eyebrow": "HELP US IMPROVE",
  "feedback.title": "Your feedback matters",
  "feedback.subtitle": "Send your suggestion or an issue you encountered directly to our team.",
  "feedback.trust.private": "Secure and private",
  "feedback.trust.direct": "Delivered directly to our team",
  "feedback.category.label": "Category",
  "feedback.category.hint": "Choose the topic that fits best.",
  "feedback.category.feature": "Feature Suggestion",
  "feedback.category.feature.description": "New ideas and improvements",
  "feedback.category.bug": "Report a Bug",
  "feedback.category.bug.description": "Technical issues you encountered",
  "feedback.category.general": "General Feedback",
  "feedback.category.general.description": "Your experience and thoughts",
  "feedback.message.label": "Your message",
  "feedback.message.sectionHint": "More detail helps us understand your feedback better.",
  "feedback.message.placeholder": "Describe your experience, suggestion, or the issue you encountered...",
  "feedback.message.hint": "Minimum 20 and maximum 1000 characters.",
  "feedback.message.ready": "Ready to send",
  "feedback.message.remaining": "Write {{count}} more characters",
  "feedback.screenshot.label": "Screenshot",
  "feedback.screenshot.sectionHint": "Add images that can help us understand the issue.",
  "feedback.screenshot.hint": "Optional · Up to 2 files · JPG, PNG, or HEIC · 7 MB per file",
  "feedback.screenshot.count": "{{count}} / 2",
  "feedback.screenshot.add": "Add",
  "feedback.screenshot.preview": "Screenshot {{index}}",
  "feedback.screenshot.remove": "Remove screenshot",
  "feedback.send": "Send",
  "feedback.sending": "Sending...",
  "feedback.privacy.title": "Secure submission",
  "feedback.privacy.message": "Your data is sent only when you tap Send.",
  "feedback.success.title": "Feedback received",
  "feedback.success.message": "Thank you for helping us improve the app.",
  "feedback.error.minLength": "Your message must be at least 20 characters.",
  "feedback.error.maxLength": "Your message can be up to 1000 characters.",
  "feedback.error.maxFiles": "You can attach up to 2 screenshots.",
  "feedback.error.fileType": "Only JPG, PNG, or HEIC files are supported.",
  "feedback.error.fileSize": "Each screenshot can be up to 7 MB.",
  "feedback.error.send": "Feedback could not be sent. Please try again.",
  "feedback.error.rateLimited": "You have sent too much feedback in a short period. Please try again later.",
  "feedback.error.invalidFile": "The screenshot could not be verified. Select a JPG, PNG, or HEIC file.",
  "admin.feedback.title": "User Feedback",
  "admin.feedback.subtitle": "Manage suggestions, bug reports, and user experience in one place.",
  "admin.feedback.cardSubtitle": "Manage suggestions, bugs, and general feedback",
  "admin.feedback.search": "Search user, email, or message",
  "admin.feedback.allStatuses": "All statuses",
  "admin.feedback.allCategories": "All categories",
  "admin.feedback.apply": "Apply",
  "admin.feedback.export": "Export CSV",
  "admin.feedback.empty": "No feedback matches these filters.",
  "admin.feedback.attachment": "Screenshot",
  "admin.feedback.close": "Close",
  "admin.feedback.previous": "Previous",
  "admin.feedback.next": "Next",
  "admin.feedback.records": "records",
  "admin.feedback.startDate": "Start date",
  "admin.feedback.endDate": "End date",
  "admin.feedback.status": "Status",
  "admin.feedback.loading": "Loading...",
  "admin.feedback.loadError": "Feedback could not be loaded.",
  "admin.feedback.statusError": "Status could not be updated.",
  "admin.feedback.attachmentError": "Screenshot could not be opened.",
  "admin.feedback.csvError": "CSV could not be created.",
  "admin.feedback.pendingNotification": "Pending notification infrastructure",
  "admin.feedback.open": "Open",
  "admin.feedback.control": "Control",
  "admin.feedback.status.new": "New",
  "admin.feedback.status.reviewing": "Reviewing",
  "admin.feedback.status.completed": "Completed",
  "admin.feedback.status.archived": "Archive",

  /* ── Home Page ── */
  "home.welcome": "Welcome",
  "home.upcomingEvents": "Upcoming Events",
  "home.noUpcoming": "No upcoming events",
  "home.shopping.title": "Shopping",
  "home.shopping.pending": "pending",
  "home.shopping.done": "done",
  "home.finance.balance": "Net Balance",
  "home.tasks.title": "Tasks",
  "home.tasks.active": "active",
  "home.sharedExpenses.title": "Shared Expenses",
  "home.health.title": "Health",
  "home.health.records": "records",
  "home.documents.title": "Documents",
  "home.children.title": "Child Tracker",
  "home.children.tracking": "tracking",
  "home.map.title": "Map",
  "home.map.sharing": "sharing",

  "member.age": "Age",
  "member.role": "Role",
  "member.familyAuthority": "Family Authority",
  "member.username": "Username",
  "member.email": "Email",
  "member.phone": "Phone",
  "member.birthDate": "Birth date",
  "member.gender": "Gender",
  "member.changeRole": "Change role",
  "member.removeFromFamily": "Remove member from family",

  /* ── Member Modal ── */
  "member.modal.title": "Member Info",

  /* ── Notification ── */
  "notification.count": "notifications",

  /* ── Family Switcher ── */
  "familySwitcher.confirmTitle": "Switch family?",
  "familySwitcher.confirmSub": "All data will switch to this family.",
  "familySwitcher.switch": "Switch",
  "familySwitcher.createFamily": "Create New Family",
  "familySwitcher.familyNameRequired": "Family name cannot be empty.",
  "familySwitcher.familyName": "Family Name",
  "familySwitcher.familyNamePlaceholder": "E.g. Yavuz Family",
  "familySwitcher.icon": "Icon",
  "familySwitcher.color": "Color",
  "familySwitcher.creating": "Creating…",
  "familySwitcher.joinFamily": "Join Family",
  "familySwitcher.joinByCode": "Join with Invite Code",
  "familySwitcher.codeRequired": "Enter the invite code.",
  "familySwitcher.joinHint": "Enter the one-time invite code created by your family admin.",
  "familySwitcher.inviteCode": "Invite Code",
  "familySwitcher.checking": "Checking…",
  "familySwitcher.myFamilies": "My Families",
  "familySwitcher.empty": "You are not a member of any family yet.",
  "familySwitcher.active": "Active",
  "familySwitcher.createSub": "Choose family name, icon and color",
  "familySwitcher.enterInviteCode": "Enter a one-time invite code",
  "familySwitcher.shareText": "🏠 Invite code to join {{name}} family: {{code}}\n\nOpen Family Planner and enter this code from the “Join by Code” section.",
  "familySwitcher.shareTitle": "{{name}} Family Invite",
  "familySwitcher.inviteCopied": "Family invite info copied.",
  "familySwitcher.shareCode": "Share Family Code",
  "familySwitcher.shareChannels": "Share via WhatsApp, SMS or Messenger",
  "familySwitcher.adminOnlyShare": "Only admins can share the family code",
  "familySwitcher.limitWarning": "Free family limit reached. Premium is required to create a new family or join by code.",
  "familySwitcher.limitMessage": "On the free plan, you can create or join up to {{limit}} family.",
  "familySwitcher.premium.multiFamily": "Multiple family groups (upgrade to Plus)",
  "familySwitcher.premium.unlimitedJoin": "Create or join up to 10 families",
  "familySwitcher.premium.quickSwitch": "Quick switching between families",
  "familySwitcher.plus.multiFamily": "Create or join up to 10 families",
  "familySwitcher.plus.unlimitedMembers": "3-member family limit completely removed",
  "familySwitcher.plus.unlimitedRecords": "Unlimited records on all pages",

  /* ── Constants / Lists ── */
  "const.roles": ["Personal", "Father", "Mother", "Child", "Uncle", "Aunt", "Aunt (paternal)", "Uncle (maternal)", "Grandfather", "Grandmother", "Other"],
  "const.genders": ["Female", "Male", "Prefer not to say"],
  "const.units": ["pcs", "kg", "lt", "pack"],
  "const.shoppingCategories": [
    "All", "Grocery", "Greengrocer", "Butcher", "Deli", "Bakery",
    "Cleaning", "Kitchen", "Beverages", "Breakfast", "Snacks",
    "Personal Care", "Baby", "Pet Supplies", "Electronics",
    "Pharmacy", "Clothing", "Home Supplies", "Other",
  ],
  "const.incomeCategories": [
    "Salary", "Extra Income", "Freelance", "Sales", "Bonus",
    "Rental Income", "Investment Return", "Government Payment",
    "Allowance", "Refund", "Transfer from Savings", "Other Income",
  ],
  "const.expenseCategories": [
    "Credit Card", "Grocery", "Bills", "Rent", "Water", "Electricity", "Gas",
    "Internet", "Phone", "Vehicle Expense", "Fuel", "Vehicle Maintenance",
    "Parking", "Insurance", "Tax", "Transportation", "Public Transport",
    "Children", "Education", "School", "Toys", "Baby Supplies",
    "Health", "Medicine", "Hospital", "Doctor Visit", "Clothing",
    "Home Supplies", "Furniture", "Cleaning", "Cosmetics",
    "Cafe & Restaurant", "Food", "Entertainment", "Vacation", "Gift",
    "Subscription", "Digital Services", "Gaming", "Software",
    "Loan", "Debt Payment", "Investment", "Savings",
    "Dues", "Other Expense",
  ],
  "const.calendarCategories": [
    "Family Event", "Appointment", "Health", "Work / Meeting",
    "School / Children", "Education / Course", "Bill / Payment", "Shopping",
    "Household Chores", "Social Gathering", "Sports / Activity", "Travel",
    "Vacation", "Official Business", "Vehicle", "Birthday", "Celebration",
    "Important", "Other",
  ],
  "const.familyAuthorities": ["Family Admin", "Family Member"],
  "const.roleSortOrder": ["Personal", "Father", "Mother", "Child", "Uncle", "Aunt", "Aunt (paternal)", "Uncle (maternal)", "Grandfather", "Grandmother", "Other"],

  /* ── Common ── */
  "common.total": "Total",
  "common.pending": "Pending",
  "common.taken": "Taken",
  "common.noData": "No data",
  "common.delete": "Delete",
  "common.expand": "Expand",
  "common.collapse": "Collapse",
  "common.add": "Add",
  "common.amount": "Amount",
  "common.date": "Date",
  "common.category": "Category",
  "common.person": "Person",
  "common.note": "Note",
  "common.title": "Title",
  "common.description": "Description",
  "common.assignee": "Assignee",
  "common.dueDate": "Due Date",
  "common.priority": "Priority",
  "common.unit": "Unit",
  "common.quantity": "Quantity",
  "common.noItems": "No records yet",
  "common.thisMonth": "This month",
  "common.records": "records",
  "common.late": "⚠ Overdue",
  "common.months": ["January","February","March","April","May","June","July","August","September","October","November","December"],

  /* ── Shopping ── */
  "shopping.addItem": "Add Item",
  "shopping.itemName": "Item name",
  "shopping.newCategory": "New category name",
  "shopping.reminder": "Set a reminder for this item",
  "shopping.reminderTitle": "🛒 Shopping Reminder",
  "shopping.reminderBody": "don't forget to buy!",
  "shopping.reminderBodyDefault": "Check your shopping list.",
  "shopping.noItems": "No items yet",
  "shopping.noCategory": "No category",
  "shopping.noAdder": "No adder",
  "shopping.listTitle": "Shopping list",
  "shopping.categories": "Shopping categories",
  "shopping.quickPlaceholder": "What should we add?",
  "shopping.details": "Add item details",
  "shopping.hideDetails": "Hide details",
  "shopping.detailsHint": "Quantity, unit, category and reminder",
  "shopping.categoriesPrevious": "Previous categories",
  "shopping.categoriesNext": "Next categories",
  "shopping.addToList": "Add to List",
  "shopping.adding": "Adding…",
  "shopping.progress.start": "Start by adding your first item",
  "shopping.progress.pendingOne": "1 item is waiting to be purchased",
  "shopping.progress.pending": "{{count}} items are waiting to be purchased",
  "shopping.progress.doneOne": "Your item has been purchased",
  "shopping.progress.done": "All {{count}} items have been purchased",
  "shopping.pendingSection": "Pending",
  "shopping.completedSection": "Purchased",
  "shopping.show": "Show",
  "shopping.hide": "Hide",
  "shopping.completeTitle": "List complete 🎉",
  "shopping.completeText": "Everything on this list has been purchased. You can review completed items below.",
  "shopping.categoryCompleteTitle": "This category is complete",
  "shopping.categoryCompleteText": "There are no pending items in this category.",
  "shopping.emptyTitle": "Your list is ready",
  "shopping.emptyText": "Add what you need and complete the shopping together without forgetting anything.",
  "shopping.emptyCategoryTitle": "No items in this category",
  "shopping.emptyCategoryText": "Choose another category or add a new item to the list.",
  "shopping.startAdding": "Add the first item",
  "shopping.markTaken": "Mark as purchased",
  "shopping.markPending": "Mark as pending",
  "shopping.moreActions": "Item actions",
  "shopping.deleteItem": "Delete item",
  "shopping.deleteConfirm": "Remove this item from the list?",
  "shopping.cancel": "Cancel",
  "shopping.deleting": "Deleting…",
  "shopping.scan.open": "Photo item options",
  "shopping.scan.camera": "Camera",
  "shopping.scan.cameraHint": "Scan a paper list",
  "shopping.scan.gallery": "Gallery",
  "shopping.scan.galleryHint": "Choose an existing image",
  "shopping.scan.scanning": "Scanning list…",
  "shopping.scan.reading": "Reading {{percent}}%…",
  "shopping.scan.noItems": "No items were detected. Try taking a clearer photo.",
  "shopping.scan.nativeOnly": "Photo scanning works in the installed mobile app. Please try on your device.",
  "shopping.scan.failed": "Scanning failed. Please try again.",
  "shopping.scan.success": "Items were added to the list successfully",

  /* ── Tasks ── */
  "tasks.create": "Create Task",
  "tasks.name": "Task name",
  "tasks.description": "Description (optional)",
  "tasks.selectPerson": "Select person",
  "tasks.priority.low": "Low",
  "tasks.priority.normal": "Normal",
  "tasks.priority.high": "High",
  "tasks.filter.all": "All",
  "tasks.filter.mine": "Assigned to Me",
  "tasks.filter.late": "Overdue",
  "tasks.filter.done": "Completed",
  "tasks.empty": "No tasks found",
  "tasks.reminder": "Set a reminder for this task",
  "tasks.reminderTitle": "✅ Task Reminder",
  "tasks.reminderBody": "don't forget your task!",
  "tasks.reminderBodyDefault": "Check your task.",
  "tasks.healthHint": "💡 This task will be automatically added to the selected person's health appointments",
  "tasks.createSubtitle": "Add tasks and responsibilities for your family",
  "tasks.openForm": "Open",
  "tasks.closeForm": "Close",
  "tasks.openFormAction": "Open form",
  "tasks.closeFormAction": "Close form",
  "tasks.creating": "Creating…",
  "tasks.overview": "Task list",
  "tasks.totalCount": "{{count}} tasks",
  "tasks.overviewDetail": "{{active}} pending · {{late}} overdue · {{done}} completed",
  "tasks.emptyTitle": "No tasks yet",
  "tasks.emptyText": "Create your first task and make everyday plans easier together.",
  "tasks.emptyLateTitle": "No overdue tasks 🎉",
  "tasks.emptyLateText": "All your tasks are progressing on time.",
  "tasks.emptyMineTitle": "No tasks assigned to you",
  "tasks.emptyMineText": "New tasks assigned to you will appear here.",
  "tasks.emptyDoneTitle": "No completed tasks yet",
  "tasks.emptyDoneText": "Tasks you complete will collect here.",
  "tasks.createFirst": "Create First Task",
  "tasks.complete": "Complete",
  "tasks.reopen": "Reopen",
  "tasks.actions": "Task actions",
  "tasks.daysLate": "{{count}} days overdue",
  "tasks.deleteTitle": "Delete task",
  "tasks.deleteConfirm": "This task will be permanently deleted. Are you sure you want to continue?",
  "tasks.deleteYes": "Yes, delete",
  "tasks.progress.start": "Create your first task",
  "tasks.progress.doneOne": "The task is complete",
  "tasks.progress.done": "All tasks are complete",
  "tasks.progress.pendingOne": "1 task is waiting to be completed",
  "tasks.progress.pending": "{{count}} tasks are waiting to be completed",
  "tasks.stats.total": "Total",
  "tasks.stats.pending": "Pending",
  "tasks.stats.completed": "Completed",
  "tasks.completeBannerTitle": "Tasks completed 🎉",
  "tasks.completeBannerText": "Great work! Every task on this list is complete.",

  /* ── Task extra categories ── */
  "const.taskExtraCategories": ["Medicine / Treatment", "Exercise", "Nutrition", "Psychology", "Dental", "Eye"],

  /* ── Shared Expenses ── */
  "expense.dashboard": "Family Expenses Dashboard",
  "expense.monthlyTotal": "Total shared expenses this month",
  "expense.perPerson": "Per Person",
  "expense.perPersonSub": "Average share",
  "expense.topSpender": "Top Spender",
  "expense.categoryCount": "Categories",
  "expense.categoryCountSub": "Different expense areas",
  "expense.byCategoryTitle": "Expenses by Category",
  "expense.noCategory": "No category data this month",
  "expense.byPersonTitle": "Expenses by Person",
  "expense.byPersonEmpty": "No per-person expense data",
  "expense.monthlyPaid": "Total paid this month",
  "expense.debtTitle": "Debt / Credit Summary",
  "expense.creditor": "Creditor",
  "expense.debtor": "Debtor",
  "expense.showDebt": "Show debt calculation",
  "expense.add": "Add Shared Expense",
  "expense.titlePlaceholder": "Title / description",
  "expense.amountPlaceholder": "Amount (₺)",
  "expense.listTitle": "Expense List",
  "expense.empty": "No expense records this month",
  "expense.noTopCategory": "No category",
  "expense.noTopSpender": "None",
  "expense.noTopSpenderData": "No data yet",
  "expense.monthRecords": "records",
  "expense.reminder": "Set a reminder for this expense",
  "expense.reminderTitle": "💸 Expense Reminder",
  "expense.showMoreExpenses": "show expenses",
  "expense.showLessRecords": "Show less",
  "expense.heaviest": "Heaviest:",

  /* ── Calendar ── */
  "calendar.addEvent": "Add Event",
  "calendar.eventTitle": "Event title",
  "calendar.eventDesc": "Description (optional)",
  "calendar.color": "Color",
  "calendar.assignee": "Person",
  "calendar.selectPerson": "Select person (optional)",
  "calendar.reminder": "Set a reminder for this event",
  "calendar.empty": "No events found",
  "calendar.upcoming": "Upcoming",
  "calendar.today": "Today",
  "calendar.filter.all": "All",
  "calendar.filter.mine": "Mine",
  "calendar.filter.upcoming": "Upcoming",
  "calendar.filter.past": "Past",
  "calendar.noUpcoming": "No upcoming events",
  "calendar.noPast": "No past events",

  /* ── Profile / Member Modal ── */
  "profile.title": "Profile",
  "profile.name": "First Name",
  "profile.surname": "Last Name",
  "profile.phone": "Phone",
  "profile.birthDate": "Birth Date",
  "profile.gender": "Gender",
  "profile.role": "Role",
  "profile.bloodType": "Blood Type",
  "profile.height": "Height",
  "profile.weight": "Weight",
  "profile.edit": "Edit Profile",
  "profile.save": "Save",
  "profile.changePassword": "Change Password",
  "profile.currentPassword": "Current password",
  "profile.newPassword": "New password",
  "profile.logout": "Sign Out",

  /* ── Premium Popup ── */
  "premium.locked": "This feature is locked",
  "premium.upgrade": "Go Premium",
  "premium.free": "Free Plan",
  "premium.monthly": "/ month",
  "premium.features": "Premium features",
  "premium.close": "Close",
  "premium.restore": "Restore purchases",
  "premium.terms": "Terms of Service",
  "premium.privacy": "Privacy Policy",
  "premium.cta": "Go Premium →",
  "premium.badge": "✦ PRO",

  /* ── Premium feature lists ── */
  "premium.hero.title1": "For Your Family,",
  "premium.hero.title2": "More",
  "premium.hero.title3": "Awaits You",
  "premium.hero.subtitle": "Manage your family better with premium features,\nstore your memories safely.",
  "premium.plan.premium": "PREMIUM",
  "premium.plan.plus": "PREMIUM PLUS",
  "premium.plan.price.premium": "₺89",
  "premium.plan.price.plus": "₺149",
  "premium.plan.cta.premium": "Go Premium",
    "premium.plan.cta.plus": "Go Premium Plus",
  "premium.comingSoon": "Coming Soon",
  "premium.comingSoonSub": "Purchasing will be available soon. For now, premium features can be enabled by your administrator.",
  "premium.comingSoonNotice": "This feature isn't available for purchase yet.",
  "premium.plan.sub.plus": "Unlimited member support for larger families and all premium features.",
  "premium.plan.sub.default": "Access all advanced features and manage your family in the best way.",
  "premium.perMonth": "/ month",
  "premium.safe": "Secure payment",
  "premium.cancel": "Cancel anytime",
  "premium.later": "Maybe later",
  "premium.restoreBtn": "Restore purchase",
  "premium.restoring": "Checking…",
  "premium.notFound": "No active subscription found.",
  "premium.restoreFailed": "Restore failed.",
  "premium.closeLabel": "Close",
  "premium.familyAlt": "Family",
  "premium.crownAlt": "Premium crown",
  "premium.features.premium": [
    {"title":"Unlimited Records","desc":"No limits on shopping, tasks, calendar, finance records"},
    {"title":"Finance Tools","desc":"Reports, savings, installments, subscriptions and bills"},
    {"title":"Live Location & Map","desc":"Live location sharing, geofence and location history"},
    {"title":"Advanced Notifications","desc":"Scheduled and automatic family notifications"},
    {"title":"Weekly Menu & Multi-Chat","desc":"Menu planning and multiple chat rooms"}
  ],
  "premium.features.plus": [
    {"title":"All Premium Features","desc":"Everything in Premium is included in Plus"},
    {"title":"Multiple Family Groups","desc":"Create or join up to 10 families"},
    {"title":"Unlimited Family Members","desc":"The 3-member limit is completely removed"},
    {"title":"Unlimited Record Entry","desc":"No data limits across all pages"},
    {"title":"Multi-Family Management","desc":"Quick switching and separate planning per family"}
  ],

  /* ── Notification Popup ── */

  /* ── Calendar specific ── */
  "calendar.days": ["Mon","Tue","Wed","Thu","Fri","Sat","Sun"],
  "calendar.daysShort": ["M","T","W","T","F","S","S"],
  "calendar.yearlyView": "Yearly View",
  "calendar.backToMonthly": "Back to monthly view",
  "calendar.goToYearly": "Switch to yearly view",
  "calendar.upcomingTitle": "Upcoming Events",
  "calendar.noRecord": "No records",
  "calendar.addBtn": "+ Add",
  "calendar.time": "Time",
  "calendar.save": "Save",
  "calendar.editTitle": "Edit Event",
  "calendar.editUpdate": "Update",
  "calendar.editBtn": "Edit",
  "calendar.deleteBtn": "Delete",
  "calendar.closeBtn": "Close",
  "calendar.dayEmpty": "No records for this day.",
  "calendar.titleRequired": "Title cannot be empty.",
  "calendar.personNotFound": "Person not found.",
  "calendar.noPermDelete": "You don't have permission to delete this event.",
  "calendar.deleteConfirm": "delete?",
  "calendar.monthlyLimitDesc": "Unlimited monthly events",
  "calendar.select": "Select",
  "calendar.labelToday": "Today",
  "calendar.labelTomorrow": "Tomorrow",
  "calendar.labelThisWeek": "This Week",
  "calendar.reminderTitle": "📅 Calendar Reminder",
  "calendar.reminderBody": "don't forget your event!",
  "calendar.bulkImport.title": "📅 Family calendar updated",
  "calendar.bulkImport.body": "{{name}} added {{count}} events from selected device calendars to the family calendar.",

  /* ── Finance ── */
  "finance.tab.general": "General",
  "finance.tab.reports": "Reports",
  "finance.tab.savings": "Savings",
  "finance.tab.installments": "Installments",
  "finance.tab.subscriptions": "Subscriptions",
  "finance.tab.bills": "Bills",
  "finance.premiumDesc": "Deeply analyze and track your financial data",
  "finance.premiumBenefit1": "Monthly expense charts",
  "finance.premiumBenefit2": "Savings and investment tracking",
  "finance.premiumBenefit3": "Installment and subscription management",
  "finance.premiumBenefit4": "Unlimited finance records",
  "finance.income": "Income",
  "finance.sharedExpense": "Shared Expense",
  "finance.topCategory": "Top Category",
  "finance.expense": "Expense",
  "finance.balance": "Net Balance",
  "finance.addRecord": "Add Record",
  "finance.titlePlaceholder": "Title",
  "finance.amountPlaceholder": "Amount",
  "finance.period": "Period",
  "finance.oneTime": "One-time",
  "finance.monthly": "Monthly",
  "finance.noRecords": "No records this period",
  "finance.filter.all": "All",
  "finance.filter.income": "Income",
  "finance.filter.expense": "Expense",
  "finance.savings.title": "Savings & Investments",
  "finance.savings.add": "Add Saving / Investment",
  "finance.savings.type": "Type",
  "finance.savings.amount": "Amount",
  "finance.savings.buyPrice": "Buy Price",
  "finance.savings.currentPrice": "Current Price",
  "finance.savings.empty": "No savings records yet",
  "finance.savings.reminderLabel": "Set a reminder for savings",
  "finance.installments.title": "Installment Tracker",
  "finance.installments.add": "Add Installment",
  "finance.installments.total": "Total",
  "finance.installments.count": "Installment Count",
  "finance.installments.paid": "Paid",
  "finance.installments.monthly": "Monthly Payment",
  "finance.installments.start": "Start",
  "finance.installments.dueDay": "Payment Day",
  "finance.installments.empty": "No installment records",
  "finance.subs.title": "Subscriptions",
  "finance.subs.add": "Add Subscription",
  "finance.subs.active": "Active",
  "finance.subs.passive": "Inactive",
  "finance.subs.empty": "No subscription records",
  "finance.bills.title": "Bills",
  "finance.bills.add": "Add Bill",
  "finance.bills.dueDate": "Due Date",
  "finance.bills.status": "Status",
  "finance.bills.paid": "Paid",
  "finance.bills.unpaid": "Unpaid",
  "finance.bills.pending": "Pending",
  "finance.bills.empty": "No bill records",
  "finance.report.title": "Finance Report",
  "finance.report.incomeExpense": "Income / Expense",
  "finance.report.categoryExpense": "Expense Categories",
  "finance.report.categoryIncome": "Income Categories",
  "finance.report.sharedExpenses": "Shared Expenses",
  "finance.newCategory": "New category",

  /* ── Health ── */
  "health.addRecord": "Add Health Record",
  "health.empty": "No health records",
  "health.type": "Record Type",
  "health.person": "Person",
  "health.date": "Date",
  "health.note": "Note",
  "health.filter.all": "All",
  "health.filter.mine": "Mine",
  "health.medicine.title": "Medicine Tracker",
  "health.medicine.add": "Add Medicine",
  "health.medicine.empty": "No medicine records",
  "health.medicine.name": "Medicine Name",
  "health.medicine.dose": "Dose",
  "health.medicine.frequency": "Frequency",
  "health.medicine.start": "Start",
  "health.medicine.end": "End",
  "health.appointment.title": "Appointments",
  "health.appointment.add": "Add Appointment",
  "health.appointment.empty": "No appointment records",
  "health.appointment.doctor": "Doctor / Clinic",
  "health.appointment.specialty": "Specialty",
  "health.appointment.date": "Date",
  "health.appointment.time": "Time",

  /* ── Children ── */
  "children.add": "Add Child / Baby",
  "children.empty": "No child tracking records",
  "children.name": "Full Name",
  "children.birthDate": "Birth Date",
  "children.gender": "Gender",
  "children.notes": "Notes",
  "children.growth.title": "Growth Tracking",
  "children.growth.height": "Height (cm)",
  "children.growth.weight": "Weight (kg)",
  "children.growth.date": "Date",
  "children.vaccine.title": "Vaccination Tracker",
  "children.vaccine.name": "Vaccine Name",
  "children.vaccine.date": "Vaccine Date",
  "children.vaccine.done": "Done",
  "children.vaccine.pending": "Pending",
  "children.milestone.title": "Development Milestones",
  "children.milestone.empty": "No records",
  "children.empty.growth": "No growth records yet.",
  "children.empty.health": "No health records yet.",
  "children.empty.routine": "No routine/activity records yet.",
  "children.empty.nutrition": "No nutrition records yet.",
  "children.empty.diaper": "No diaper records yet.",
  "children.empty.care": "No care records yet.",
  "children.empty.memory": "No memory records yet.",
  "children.empty.general": "No records yet.",
  "children.section.growth": "Growth Tracking",
  "children.section.nutrition": "Nutrition",
  "children.section.routine.baby": "Sleep",
  "children.section.diaper": "Diaper Tracking",
  "children.section.health": "Health",
  "children.section.memory": "Memories",
  "children.section.health.pet": "Health / Vet",
  "children.section.care": "Care",
  "children.section.routine.pet": "Activity",
  "children.section.growth.pet": "Weight / Growth",
  "children.section.education": "School / Education",
  "children.section.routine": "Daily Routine",

  /* ── Chat ── */
  "chat.placeholder": "Write a message…",
  "chat.send": "Send",
  "chat.empty": "No messages yet",
  "chat.newRoom": "New Room",
  "chat.deleteRoom": "Delete Room",
  "chat.roomName": "Room name",
  "chat.you": "You",
  "chat.today": "Today",
  "chat.yesterday": "Yesterday",
  "chat.noRooms": "No conversations yet",
  "chat.noRoomsSub": "Tap the + button to start a new conversation",
  "chat.noMessages": "No messages yet",
  "chat.noMessagesSub": "Be the first to send a message!",
  "chat.noResults": "No results found",
  "chat.searchPlaceholder": "Search messages...",
  "chat.inputPlaceholder": "Write something…",
  "chat.deleteMsg": "Delete message",
  "chat.roomNamePlaceholder": "E.g. Weekend plans",

  /* ── Documents ── */
  "documents.add": "Upload Document",
  "documents.empty": "No documents",
  "documents.name": "Document Name",
  "documents.type": "Type",
  "documents.owner": "Owner",
  "documents.expiry": "Expiry",
  "documents.expired": "Expired ⚠️",
  "documents.valid": "Valid ✓",
  "documents.daysLeft": "days left",
  "documents.expiresSoon": "Expiring Soon",
  "documents.noExpiry": "No Expiry",
  "documents.download": "Download",
  "documents.delete": "Delete",
  "documents.filter.all": "All",
  "documents.filter.mine": "Mine",
  "documents.filter.expiring": "Expiring Soon",
  "documents.newVersion": "New Version",
  "documents.versions": "Versions",

  /* ── User Management ── */
  "management.title": "Management",
  "management.members": "Members",
  "management.permissions": "Permissions",
  "management.invite": "Invite",
  "management.remove": "Remove",
  "management.role": "Role",
  "management.authority": "Authority",
  "management.save": "Save",
  "management.saved": "Saved ✓",
  "management.empty": "No members",
  "management.tab.pages": "Pages",
  "management.tab.actions": "Actions",
  "management.tab.password": "Password",
  "management.tab.profile": "Profile",
  "management.profileRoleTitle": "Membership and family role",
  "management.profileRoleDesc": "Premium profile management synced with the Family card.",
  "management.memberRole": "Family role",
  "management.membershipType": "Membership type",
  "management.selectRole": "Select role",
  "management.profileRoleSyncDesc": "Changes made here appear on the Family card, and Family card changes appear here with the same data.",
  "management.passwordResetFailed": "Password reset email could not be sent.",
  "family.error.passwordResetFailed": "Password reset email could not be sent. Please check the email address and Firebase Auth status.",
  "family.error.passwordResetUserNotFound": "No Firebase Auth user was found for this email address.",
  "family.error.invalidEmail": "No valid email address was found.",
  "management.saving": "Saving...",
  "management.template": "Quick Template",
  "management.template.custom": "Custom",
  "management.template.full": "Full Access",
  "management.template.standard": "Standard Member",
  "management.template.child": "Child",
  "management.template.viewonly": "View Only",
  "management.passwordReset": "📨 Send Password Reset Email",
  "management.passwordResetDesc": "Send a password reset email to this user. They can click the link in the email to set a new password.",
  "management.noEmail": "Email not found",
  "management.passwordResetSent": "Password reset email sent ✓",

  /* ── Common extra ── */
  "common.all": "All",
  "common.other": "Other",
  "common.search": "Search",
  "common.notification.count": "notifications",

  /* ── Health card titles ── */
  "health.card.summary": "Health Summary",
  "health.card.medicine": "Medicine Tracker",
  "health.card.appointment": "Appointments",
  "health.card.measurement": "Measurements",
  "health.card.report": "Tests / Reports",
  "health.card.allergy": "Allergies",
  "health.card.condition": "Chronic Conditions",
  "health.card.vaccine": "Vaccination Tracker",
  "health.card.emergency": "Emergency Card",
  "health.card.note": "Health Notes",
  "health.myProfile": "My Health Profile",
  "health.noBirthDate": "No birth date",
  "health.noBloodType": "No blood type",
  "health.noRole": "Family member",
  "health.notSpecified": "Not specified",
  "health.save": "Save",
  "health.cancel": "Cancel",
  "health.addToCalendar": "Add to calendar",
  "health.createTask": "Create task",

  /* ── Common type/status ── */
  "common.type": "Type",
  "common.status": "Status",
  "common.all2": "All",

  /* ── Health detail texts ── */
  "health.myInfo": "My Health Info",
  "health.myInfoDesc": "Blood type, emergency contact, allergies, doctor and personal notes",
  "health.select": "Select",
  "health.status.pending": "Pending",
  "health.status.done": "Done",
  "health.status.active": "Active tracking",
  "health.status.passive": "Inactive/past",
  "health.status.dotDone": "● Done",
  "health.status.dotLate": "● Late",
  "health.status.dotPending": "○ Pending",
  "health.status.dotCompleted": "● Completed",
  "health.status.dotPassive": "○ Inactive",
  "health.status.dotActive": "● Active",
  "health.medicine.planTitle": "Create medication plan",
  "health.medicine.planDesc": "Each hour tracked as a separate dose with push notification when due.",
  "health.appointment.type": "Appointment type",
  "health.appointment.note": "Appointment note",
  "health.appointment.default": "Health Appointment",
  "health.measurement.typePlaceholder": "Select or type measurement type",
  "health.measurement.default": "Measurement",
  "health.section.intro.appointment": "Linked to calendar, can also be tracked as a task.",
  "health.section.intro.measurement": "Regularly track blood pressure, sugar, pulse, weight and more.",
  "health.record.noAppointment": "None",
  "health.record.noMeasurement": "None",
  "health.record.nextAppt": "📅 Next Appointment",
  "health.record.lastMeasurement": "🩺 Last Measurement",
  "health.record.reports": "📄 Reports",
  "health.record.recordCount": "records",
  "health.summary.label": "❤️ Health summary",
  "health.summary.noData": "Add health data",
  "health.summary.emergencyCard": "Emergency card",
  "health.summary.todayDosesDone": "Today's doses done",
  "health.summary.noMedicine": "No medicines",
  "health.summary.activeMedicine": "active medicines",
  "health.summary.appointment": "Appointment:",
  "health.summary.chronic": "chronic",
  "health.summary.emergencyAvail": "Emergency card available",
  "health.dose.label": "💉 Dose",
  "health.dose.plan": "📅 Plan",
  "health.dose.done": "✅ Done",
  "health.dose.yes": "Yes",
  "health.dose.no": "No",
  "health.dose.next": "🔜 Next",
  "health.dose.note": "📝 Note",
  "health.premium.title": "Health records",
  "health.premium.b1": "Unlimited health records per person",
  "health.premium.b2": "Medicine and reminder tracking",
  "health.premium.b3": "Allergy and chronic condition tracking",
  "health.premium.b4": "Unlimited usage across all modules",
  "health.section.intro.report": "Upload and track test results, reports and health documents.",
  "health.section.intro.allergy": "Track allergies, severity, symptoms and emergency actions.",
  "health.section.intro.condition": "Track chronic conditions, doctors and follow-up frequency.",
  "health.section.intro.vaccine": "Track planned and completed vaccinations.",
  "health.section.intro.emergency": "Store critical emergency contact and medical information.",
  "health.section.intro.note": "Keep general health notes in one place.",
  "health.category": "Appointment",
  "health.bloodContext.ac": "Fasting",
  "health.bloodContext.tok": "Full",
  "health.bloodContext.rest": "Resting",
  "health.bloodContext.postEx": "Post-exercise",
  "health.bloodContext.night": "Night",

  /* ── Finance extra ── */
  "finance.savings.portfolio": "Savings Portfolio",
  "finance.savings.portfolioDesc": "Manual tracking of gold, deposits, stocks, crypto, forex, property and other savings.",
  "finance.backToFinance": "Back to Finance",
  "finance.savings.addPlaceholder": "Saving name: Gold, THYAO, BTC...",
  "finance.savings.amountPlaceholder": "Amount / units / grams",
  "finance.savings.buyPricePlaceholder": "Buy price",
  "finance.savings.currentPricePlaceholder": "Current price",
  "finance.savings.goldAmountPlaceholder": "Amount / grams / units",
  "finance.savings.buyUnitPricePlaceholder": "Buy unit price",
  "finance.savings.currentUnitPricePlaceholder": "Current unit price",
  "finance.savings.bankPlaceholder": "Bank name",
  "finance.savings.principalPlaceholder": "Principal / total amount",
  "finance.savings.interestRatePlaceholder": "Interest rate (%)",
  "finance.savings.currentTotalValuePlaceholder": "Current total value",
  "finance.savings.stockCodePlaceholder": "Stock symbol: THYAO, ASELS...",
  "finance.savings.stockNamePlaceholder": "Stock name",
  "finance.savings.lotAmountPlaceholder": "Lot amount",
  "finance.savings.coinSymbolPlaceholder": "Coin symbol: BTC, ETH...",
  "finance.savings.coinNamePlaceholder": "Coin name",
  "finance.savings.cryptoAmountPlaceholder": "Coin amount",
  "finance.savings.platformPlaceholder": "Exchange / platform",
  "finance.savings.currencyAmountPlaceholder": "Currency amount",
  "finance.savings.buyRatePlaceholder": "Buy rate",
  "finance.savings.currentRatePlaceholder": "Current rate",
  "finance.savings.fundCodePlaceholder": "Fund code",
  "finance.savings.fundNamePlaceholder": "Fund name",
  "finance.savings.shareAmountPlaceholder": "Share amount",
  "finance.savings.cashAmountPlaceholder": "Cash amount",
  "finance.savings.storagePlacePlaceholder": "Storage place: bank, safe, wallet...",
  "finance.savings.notePlaceholder": "Note",
  "finance.savings.updatePrice": "Current rate / price",
  "finance.savings.updatePriceHint": "Enter the new value; all records for the same asset update together.",
  "finance.savings.update": "Update",
  "finance.savings.cost": "Cost",
  "finance.savings.currentValue": "Current Value",
  "finance.savings.profitLoss": "Profit / Loss",
  "finance.savings.units": "units",
  "finance.savings.buyDate": "Bought",
  "finance.savings.datePlaceholder": "Purchase / record date",
  "finance.savings.termStartDatePlaceholder": "Term start date",
  "finance.savings.termEndDatePlaceholder": "Term end date",
  "finance.validation.title": "Required information is missing",
  "finance.validation.fillFields": "Please complete the fields outlined in red:",
  "finance.validation.installmentName": "Installment name",
  "finance.validation.installmentCounts.title": "Check the installment details",
  "finance.validation.installmentCounts.totalRequired": "The number of installments is required.",
  "finance.validation.installmentCounts.totalInteger": "The number of installments must be a whole number.",
  "finance.validation.installmentCounts.totalRange": "The number of installments must be between 1 and {{max}}.",
  "finance.validation.installmentCounts.paidRequired": "The number of paid installments is required.",
  "finance.validation.installmentCounts.paidInteger": "The number of paid installments must be a whole number.",
  "finance.validation.installmentCounts.paidNonNegative": "The number of paid installments cannot be negative.",
  "finance.validation.installmentCounts.paidExceedsTotal": "Paid installments cannot exceed the total number of installments.",
  "finance.validation.installmentCounts.paidChangeLimit": "You can change at most {{limit}} installments in a single operation.",
  "finance.action.adding": "Adding...",
  "finance.debt.gold.category": "Gold Debt",
  "finance.debt.fx.category": "Foreign Currency Debt",
  "finance.debt.gold.title": "Gold debt plan",
  "finance.debt.gold.hint": "Track each gold item and your monthly payment plan. Current value is calculated from the app's market prices.",
  "finance.debt.fx.title": "Foreign currency debt plan",
  "finance.debt.fx.hint": "Choose the debt and payment currencies separately and follow the balance with current exchange rates.",
  "finance.debt.gold.item": "Gold item",
  "finance.debt.gold.addItem": "Add gold item",
  "finance.debt.gold.addPaymentItem": "Add gold to payment",
  "finance.debt.gold.amount": "Gold amount",
  "finance.debt.gold.quantityPieces": "Quantity",
  "finance.debt.gold.quantityGram": "Total grams",
  "finance.debt.gold.quantityOunce": "Troy ounces",
  "finance.debt.gold.karat": "Karat (required)",
  "finance.debt.gold.purity": "Fineness (required)",
  "finance.debt.gold.type.gram": "Gold by gram",
  "finance.debt.gold.type.quarter": "Quarter gold coin",
  "finance.debt.gold.type.half": "Half gold coin",
  "finance.debt.gold.type.full": "Full gold coin",
  "finance.debt.gold.type.republic": "Republic gold coin",
  "finance.debt.gold.type.ata": "Ata gold coin",
  "finance.debt.gold.type.bracelet": "Gold bracelet",
  "finance.debt.gold.type.other_jewelry": "Other gold jewellery",
  "finance.debt.gold.type.ounce": "Gold by troy ounce",
  "finance.debt.gold.type.bar": "Gold bar",
  "finance.debt.gold.type.coin": "Gold coin",
  "finance.debt.gold.type.jewelry": "Gold jewellery",
  "finance.debt.gold.type.custom": "Custom gold item",
  "finance.debt.fx.principal": "Total foreign currency debt",
  "finance.debt.fx.currency": "Debt currency",
  "finance.debt.monthlyPayment": "Monthly payment amount",
  "finance.debt.setReminder": "Set a custom reminder for this debt",
  "finance.debt.customReminderTitle": "🔔 Your debt plan reminder",
  "finance.debt.customReminderBody": "It’s time for the personal reminder you set for \"{{name}}\".",
  "finance.debt.reminderSaveFailed": "The debt was saved, but its custom reminder could not be created. Edit the record and try again.",
  "finance.debt.progress": "Debt repayment progress",
  "finance.debt.estimatedMonths": "Estimated months left",
  "finance.debt.remainingPrincipal": "remaining principal",
  "finance.debt.nextPayment": "Next payment",
  "finance.debt.estimatedEnd": "Estimated completion",
  "finance.debt.marketUpdated": "Market updated",
  "finance.debt.marketMayBeStale": "Market prices may be out of date",
  "finance.debt.addPayment": "Add payment",
  "finance.debt.paymentTitle": "Add debt payment",
  "finance.debt.payment.money": "Pay with money",
  "finance.debt.payment.gold": "Pay with gold",
  "finance.debt.payment.mixed": "Mixed payment",
  "finance.debt.payment.amount": "Money amount paid",
  "finance.debt.payment.date": "Payment date",
  "finance.debt.payment.note": "Payment note (optional)",
  "finance.debt.payment.save": "Save payment",
  "finance.debt.payment.history": "Recent payments",
  "finance.debt.paymentRequired": "Enter the money or gold amount required for the selected payment type.",
  "finance.debt.paymentFailed": "The debt payment could not be saved. Please try again.",
  "finance.debt.estimateDisclaimer": "The estimate assumes current gold or exchange rates remain unchanged.",
  "finance.goldDebt.tomorrowTitle": "✨ Your gold debt payment is due tomorrow",
  "finance.goldDebt.todayTitle": "✨ Your gold debt payment is due today",
  "finance.goldDebt.tomorrowBody": "Your planned {{amount}} payment for \"{{name}}\" is due tomorrow. Let’s keep your plan moving forward 😊",
  "finance.goldDebt.todayBody": "Your payment for \"{{name}}\" is due today. Every steady step makes the debt lighter 💛",
  "finance.fxDebt.tomorrowTitle": "💱 Your currency debt payment is due tomorrow",
  "finance.fxDebt.todayTitle": "💱 Your currency debt payment is due today",
  "finance.fxDebt.tomorrowBody": "You have a planned {{amount}} payment for \"{{name}}\" tomorrow. A little heads-up 😊",
  "finance.fxDebt.todayBody": "Your payment for \"{{name}}\" is due today. You can complete another step in your plan 💪",
  "finance.realEstate.add": "Add Property",
  "finance.realEstate.formTitle": "Property details",
  "finance.realEstate.formHint": "Enter the essentials for accurate tracking; optional details can be updated at any time.",
  "finance.realEstate.identitySection": "Property and location",
  "finance.realEstate.valueSection": "Value and use",
  "finance.realEstate.ownershipSection": "Ownership and financing",
  "finance.realEstate.name": "Property name",
  "finance.realEstate.namePlaceholder": "e.g. Downtown apartment, Lakeside land",
  "finance.realEstate.type": "Property type",
  "finance.realEstate.typePlaceholder": "Select a type",
  "finance.realEstate.type.apartment": "Apartment",
  "finance.realEstate.type.house": "Detached house",
  "finance.realEstate.type.villa": "Villa",
  "finance.realEstate.type.land": "Land / plot",
  "finance.realEstate.type.commercial": "Commercial property",
  "finance.realEstate.type.office": "Office",
  "finance.realEstate.type.shop": "Retail unit",
  "finance.realEstate.type.warehouse": "Warehouse",
  "finance.realEstate.type.other": "Other",
  "finance.realEstate.city": "City",
  "finance.realEstate.cityPlaceholder": "e.g. London",
  "finance.realEstate.district": "District",
  "finance.realEstate.districtPlaceholder": "e.g. Camden",
  "finance.realEstate.neighborhood": "Neighborhood / area",
  "finance.realEstate.neighborhoodPlaceholder": "e.g. Hampstead",
  "finance.realEstate.area": "Gross area",
  "finance.realEstate.rooms": "Rooms",
  "finance.realEstate.roomsPlaceholder": "e.g. 3 bed",
  "finance.realEstate.currency": "Currency",
  "finance.realEstate.purchasePrice": "Purchase price",
  "finance.realEstate.currentValue": "Current estimated value",
  "finance.realEstate.purchaseDate": "Acquisition date",
  "finance.realEstate.useStatus": "Occupancy status",
  "finance.realEstate.use.owner_occupied": "Family occupied",
  "finance.realEstate.use.rented": "Rented",
  "finance.realEstate.use.vacant": "Vacant",
  "finance.realEstate.use.under_construction": "Under construction",
  "finance.realEstate.monthlyRent": "Monthly rental income",
  "finance.realEstate.leaseStart": "Lease start date",
  "finance.realEstate.deedStatus": "Ownership status",
  "finance.realEstate.deed.full": "Full ownership",
  "finance.realEstate.deed.shared": "Shared ownership",
  "finance.realEstate.deed.mortgaged": "Mortgaged",
  "finance.realEstate.deed.other": "Other",
  "finance.realEstate.ownershipShare": "Ownership share (%)",
  "finance.realEstate.remainingLoan": "Outstanding mortgage",
  "finance.realEstate.monthlyLoanPayment": "Monthly mortgage payment",
  "finance.realEstate.valueChange": "Value change",
  "finance.realEstate.netEquity": "Net equity",
  "finance.realEstate.grossYield": "Estimated gross rental yield",
  "finance.realEstate.updateValue": "Update Value",
  "finance.realEstate.updateValueHint": "Enter the latest estimated market value.",
  "finance.realEstate.emptyTitle": "No properties yet",
  "finance.realEstate.emptyText": "Add your first property and keep its value, rental income and financing status up to date.",
  "finance.installments.hero": "Installment Tracker",
  "finance.installments.heroDesc": "Total installment due this month. Track all installments in one place.",
  "finance.installments.namePlaceholder": "Name: Phone, appliance, loan...",
  "finance.installments.totalPlaceholder": "Total amount",
  "finance.installments.countPlaceholder": "Number of installments",
  "finance.installments.paidCountPlaceholder": "Installments paid",
  "finance.installments.monthlyPlaceholder": "Monthly payment (auto if empty)",
  "finance.installments.dueDayPlaceholder": "Payment due day",
  "finance.installments.notePlaceholder": "Note",
  "finance.installments.paidOf": "paid",
  "finance.installments.monthlyPayment": "Monthly Payment",
  "finance.installments.remaining": "Remaining",
  "finance.installments.remainingDebt": "Remaining Debt",
  "finance.installments.eachMonth": "Every month on",
  "finance.installments.day": "",
  "finance.installments.reminderLabel": "Set a reminder for installment payment",
  "finance.notifyTarget.title": "Who should receive automatic reminders?",
  "finance.notifyTarget.self": "Only me",
  "finance.notifyTarget.admins": "Family admins",
  "finance.notifyTarget.selected": "Selected family members",
  "finance.notifyTarget.all": "Whole family",
  "finance.notifyTarget.hint": "This only affects automatic finance reminders. If a user has Finance Notifications turned off, they will not receive it.",
  "finance.notifyTarget.noMembers": "No family members to select.",
  "finance.notifyTarget.member": "Family member",
  "finance.installments.startDatePlaceholder": "Start date",
  "finance.subs.hero": "Subscription Tracker",
  "finance.subs.heroDesc": "Total monthly subscription cost",
  "finance.subs.activeCount": "active subscriptions",
  "finance.subs.platform": "Platform / Service",
  "finance.subs.selectPlatform": "Select...",
  "finance.subs.renewalPeriod": "Renewal Period",
  "finance.subs.nextPayment": "Next Payment",
  "finance.subs.payer": "Who Pays",
  "finance.subs.payerPlaceholder": "Name",
  "finance.subs.status": "Status",
  "finance.subs.statusActive": "Yes",
  "finance.subs.statusInactive": "No",
  "finance.subs.notePlaceholder": "Note (optional)",
  "finance.subs.toggleActive": "Activate",
  "finance.subs.togglePassive": "Deactivate",
  "finance.subs.activeLabel": "Active",
  "finance.subs.passiveLabel": "Inactive",
  "finance.subs.monthlyCost": "Monthly Cost",
  "finance.subs.yearlyCost": "Yearly Cost",
  "finance.subs.nextPaymentLabel": "Next payment:",
  "finance.subs.reminderLabel": "Set a renewal reminder",
  "finance.subs.manualName": "Enter subscription name",
  "finance.subs.amount": "Amount",
  "finance.subs.currency": "Currency",
  "finance.bills.hero": "Bill Tracker",
  "finance.bills.heroDesc": "Total unpaid bills",
  "finance.bills.pendingCount": "pending",
  "finance.bills.type": "Bill Type",
  "finance.bills.period": "Period",
  "finance.bills.manualName": "Enter bill name",
  "finance.bills.amount": "Amount",
  "finance.bills.currency": "Currency",
  "finance.bills.dueDate2": "Due Date",
  "finance.bills.payer": "Who Pays",
  "finance.bills.payerPlaceholder": "Name (optional)",
  "finance.bills.notePlaceholder": "Note (optional)",
  "finance.bills.reminderLabel": "Set a bill due date reminder",
  "finance.bills.markPaid": "Mark as paid",
  "finance.bills.markUnpaid": "Mark as unpaid",
  "finance.bills.paidBtn": "Paid ✓",
  "finance.bills.payBtn": "Pay",
  "finance.bills.dueDateLabel": "Due Date",
  "finance.bills.statusLabel": "Status",
  "finance.bills.overdue": "days overdue",
  "finance.bills.daysLeft": "days left",
  "finance.bills.carryover.eyebrow": "Carried over",
  "finance.bills.carryover.title": "Outstanding bills",
  "finance.bills.carryover.hint": "Bills left unpaid from previous months stay here until you mark them as paid.",
  "finance.bills.carryover.count": "{{count}} overdue bills",
  "finance.bills.carryover.badge": "Overdue",
  "finance.bills.currentMonth.eyebrow": "Selected period",
  "finance.bills.currentMonth.title": "This month's bills",
  "finance.bills.quick.eyebrow": "Ready from last month",
  "finance.bills.quick.title": "Quick add bills",
  "finance.bills.quick.hint": "Update the amount and due date; the remaining details will be copied safely from last month.",
  "finance.bills.quick.lastMonth": "From last month's record",
  "finance.bills.quick.add": "Add to this month",
  "finance.bills.quick.adding": "Adding...",
  "finance.bills.quick.validation": "Check the bill amount and due date.",
  "finance.bills.quick.error": "The bill could not be added to this month. Please try again.",
  "finance.report.last30": "Last 30 Days Trend",
  "finance.report.last30empty": "No income/expense records to chart for the last 30 days",

  /* ── Management notification panel ── */
  "mgmt.repeat.none": "One-time",
  "mgmt.repeat.hourly": "Every Hour",
  "mgmt.repeat.daily": "Every Day",
  "mgmt.repeat.every3days": "Every 3 Days",
  "mgmt.repeat.weekly": "Every Week",
  "mgmt.repeat.monthly": "Every Month",
  "mgmt.target.allUsers": "All users",
  "mgmt.target.familyUsers": "Family members",
  "mgmt.target.users": "Selected users",
  "mgmt.send.now": "Send Now",
  "mgmt.send.scheduled": "Schedule",
  "mgmt.send.scheduledAlt": "Scheduled Send",
  "mgmt.notify.prepare": "🔔 Prepare Family Notification",
  "mgmt.notify.recent": "🕘 Recently Sent",
  "mgmt.notify.scheduled": "⏰ Scheduled Notifications",
  "mgmt.notify.systemAnnouncement": "📢 System Announcement to All Users",
  "mgmt.notify.automation": "⚙️ Automatic Notification Rules",
  "mgmt.notify.repeatAnnouncements": "📢 Recurring System Announcements",
  "mgmt.notify.recentLogs": "🕘 Recent Run Logs",
  "mgmt.notify.automationTitle": "⚙️ Notification Automation",
  "mgmt.notify.quietHours": "🌙 Global Quiet Hours Policy",
  "mgmt.notify.policyTitle": "🔧 Notification Schedule Policies",
  "mgmt.notify.scheduled2": "⏰ Scheduled Notifications",
  "mgmt.notify.readers": "Readers",
  "mgmt.notify.noReaders": "No readers yet.",
  "mgmt.notify.unread": "Unread",
  "mgmt.notify.allRead": "Everyone has read.",
  "mgmt.notify.lastRun": "Last run",
  "mgmt.notify.result": "Result",
  "mgmt.notify.sentPush": "Push sent",
  "mgmt.notify.error": "Error",
  "mgmt.notify.activeScheduled": "Active scheduled notifications",
  "mgmt.notify.pendingNotif": "Pending notifications",
  "mgmt.notify.todaySent": "Sent today",
  "mgmt.notify.applyQuiet": "Apply quiet hours system-wide",
  "mgmt.notify.respectQuiet": "Respect quiet hours",
  "mgmt.notify.blockRepeat": "Block repeated notifications",
  "mgmt.notify.target": "Target user",
  "mgmt.notify.pendingTotal": "Pending total",
  "mgmt.notify.filtered": "Filtered",
  "mgmt.notify.repeat": "Recurring",
  "mgmt.notify.targetLabel": "Target:",
  "mgmt.notify.targetCount": "Target count:",
  "mgmt.notify.repeatLabel": "Repeat:",
  "mgmt.notify.planLabel": "Plan:",
  "mgmt.notify.typeLabel": "Type:",
  "mgmt.notify.creatorLabel": "Creator:",
  "mgmt.notify.statusPending": "pending",
  "mgmt.profile.email": "📧",

  /* ── Permission labels ── */
  "perm.addShopping": "Can add items",
  "perm.deleteOwnShopping": "Can delete own items",
  "perm.deleteAllShopping": "Can delete all items",
  "perm.addCalendarEvent": "Can add events",
  "perm.updateOwnCalendarEvent": "Can edit own events",
  "perm.updateAllCalendarEvents": "Can edit all events",
  "perm.deleteOwnCalendarEvent": "Can delete own events",
  "perm.deleteAllCalendarEvents": "Can delete all events",
  "perm.addFinance": "Can add income/expense",
  "perm.deleteOwnFinance": "Can delete own records",
  "perm.deleteAllFinance": "Can delete all records",
  "perm.addTask": "Can create tasks",
  "perm.completeOwnTask": "Can complete own tasks",
  "perm.completeAllTasks": "Can complete all tasks",
  "perm.deleteOwnTask": "Can delete own tasks",
  "perm.deleteAllTasks": "Can delete all tasks",
  "perm.addSharedExpense": "Can add expenses",
  "perm.deleteOwnSharedExpense": "Can delete own expenses",
  "perm.deleteAllSharedExpense": "Can delete all expenses",
  "perm.addHealthRecord": "Can add health records",
  "perm.deleteOwnHealthRecord": "Can delete own health records",
  "perm.deleteAllHealthRecords": "Can delete all health records",
  "perm.addMapPlace": "Can add shared places",
  "perm.deleteOwnMapPlace": "Can delete own places",
  "perm.deleteAllMapPlaces": "Can delete all places",
  "perm.shareLocation": "Can share location",
  "perm.addChildRecord": "Can add child/baby/pet records",
  "perm.deleteOwnChildRecord": "Can delete own records",
  "perm.deleteAllChildRecords": "Can delete all child/baby/pet records",
  "perm.sendMessage": "Can send messages",
  "perm.editOwnMessage": "Can edit own messages",
  "perm.deleteOwnMessage": "Can delete own messages",
  "perm.deleteAllMessages": "Can delete all messages",
  "perm.pinMessage": "Can pin messages",
  "perm.sendMedia": "Can send photos/files",
  "perm.reactMessage": "Can add reactions",
  "perm.addDocument": "Can upload documents",
  "perm.deleteOwnDocument": "Can delete own documents",
  "perm.deleteAllDocuments": "Can delete all documents",
  "perm.generateMealSuggestion": "Can get meal suggestions",
  "perm.rateMealSuggestion": "Can like/dislike meal suggestions",
  "perm.manageMealSuggestions": "Can manage meal suggestions",
  "perm.addCategory": "Can add categories",
  "perm.manageUsers": "Can manage user permissions",
  "perm.sendFamilyNotification": "Can send family notifications",
  "perm.manageScheduledNotifications": "Can manage scheduled notifications",
  "perm.manageNotificationAutomation": "Can manage notification automation",
  "perm.sendSystemAnnouncement": "Can send system announcements",

  /* ── Chat extra ── */
  "chat.pin": "📌 Pin",
  "chat.unpin": "📌 Unpin",
  "chat.premium.multiRoom": "Multiple chat rooms",
  "chat.premium.multiRoomDesc": "Create chat rooms for different topics for your family",
  "chat.premium.b1": "Unlimited chat rooms",
  "chat.premium.b2": "Unlimited message history",
  "chat.premium.b3": "Group and private chat",
  "chat.premium.b4": "Media sharing",
  "chat.newRoomBtn": "+ New Chat",

  /* ── UserManagement notification templates ── */
  "mgmt.notif.template.home.title": "Share Your Arrival Time",
  "mgmt.notif.template.home.desc": "Could you share what time you'll be home today?",
  "mgmt.notif.template.dinner.title": "Dinner is Ready",
  "mgmt.notif.template.dinner.desc": "Food is ready. Everyone who's available can come to the table. Enjoy! ❤️",
  "mgmt.notif.template.meeting.title": "Family Gathering Reminder",
  "mgmt.notif.template.meeting.desc": "There's something we need to discuss as a family today.",
  "mgmt.notif.template.shopping.title": "Check Home Supplies",
  "mgmt.notif.template.shopping.desc": "There might be things needed at home. Could you check the shopping list?",
  "mgmt.notif.template.location.title": "Location / I'm Safe Check",
  "mgmt.notif.template.location.desc": "When available, could you share your location or let the family know you're safe?",
  "mgmt.notif.template.emergency.desc": "There's something important and urgent for the family. Please check the app ASAP.",
  "mgmt.notif.priority.normal": "🔔 Normal",
  "mgmt.notif.priority.priority": "⚡ Priority",
  "mgmt.notif.priority.announce": "📢 Announcement",
  "mgmt.notif.priority.silent": "🔕 Silent",
  "mgmt.auto.template.welcome.title": "Family Planner is waiting for you",
  "mgmt.auto.template.welcome.desc": "Don't forget to check family plans and notifications.",
  "mgmt.auto.template.tasks.title": "Check your tasks",
  "mgmt.auto.template.tasks.desc": "There might be tasks assigned to you. Take a look now.",
  "mgmt.auto.template.calendar.title": "Check the Calendar",
  "mgmt.auto.template.calendar.desc": "Check the calendar so you don't miss upcoming family events.",
  "mgmt.auto.template.shopping.title": "Check the shopping list",
  "mgmt.auto.template.shopping.desc": "There might be pending items on your family's shopping list.",
  "mgmt.auto.template.documents.title": "Check Documents",
  "mgmt.auto.template.documents.desc": "There might be records to check in the document vault.",
  "mgmt.auto.template.general.title": "General Information",
  "mgmt.auto.template.general.desc": "There's a new update in the Family Planner app.",
  "mgmt.sys.maintenance.title": "Planned Maintenance",
  "mgmt.sys.maintenance.desc": "A brief planned maintenance will be performed.",
  "mgmt.sys.newfeature.title": "New Feature Live",
  "mgmt.sys.newfeature.desc": "A new feature has been added to Family Planner.",
  "mgmt.sys.update.title": "App Updated",
  "mgmt.sys.update.desc": "A new update with better performance and bug fixes is now live.",
  "mgmt.sys.performance.title": "Performance Improvement",
  "mgmt.sys.performance.desc": "Speed and stability improvements have been made.",
  "mgmt.sys.notification.title": "Notification System Renewed",
  "mgmt.sys.notification.desc": "The push notification system has been improved.",
  "mgmt.sys.outage.title": "Brief Service Work",
  "mgmt.sys.outage.desc": "A brief maintenance will be performed on the infrastructure.",
  "mgmt.sys.sync.title": "Data Synchronization",
  "mgmt.sys.sync.desc": "An improvement has been made for more regular data synchronization.",
  "mgmt.sys.announcement.title": "General System Announcement",
  "mgmt.sys.announcement.desc": "An important update about Family Planner has been shared.",
  "mgmt.sys.thanks.title": "Thank You",
  "mgmt.sys.thanks.desc": "Thank you for using Family Planner. We continue to improve your experience.",
  "mgmt.sys.newyear.title": "🎉 New Year Celebration",
  "mgmt.sys.newyear.desc": "Happy New Year from the Family Planner team! We're here for you again this year.",
  "mgmt.sys.ramadan.title": "🌙 Ramadan Greeting",
  "mgmt.sys.ramadan.desc": "Wishing you a blessed Ramadan month full of good things.",
  "mgmt.sys.eid.title": "🌟 Holiday Greeting",
  "mgmt.sys.eid.desc": "Wishing you a joyful holiday with our warmest regards.",
  "mgmt.sys.birthday_app.title": "🎂 App Anniversary",
  "mgmt.sys.birthday_app.desc": "We've completed another year with Family Planner — thank you for being with us!",
  "mgmt.sys.premium_offer.title": "💎 Premium Offer",
  "mgmt.sys.premium_offer.desc": "Don't miss our limited-time premium offer — unlock all features.",
  "mgmt.sys.premium_renewal.title": "🔁 Premium Renewal Reminder",
  "mgmt.sys.premium_renewal.desc": "Your premium membership renewal date is approaching.",
  "mgmt.sys.backup_done.title": "💾 Backup Completed",
  "mgmt.sys.backup_done.desc": "Your family data has been successfully backed up.",
  "mgmt.sys.backup_reminder.title": "🗄️ Backup Reminder",
  "mgmt.sys.backup_reminder.desc": "We recommend taking a fresh backup of your data.",
  "mgmt.sys.tip_shopping.title": "🛒 Tip: Shopping List",
  "mgmt.sys.tip_shopping.desc": "Did you know you can share your shopping list with family members and manage it together?",
  "mgmt.sys.tip_calendar.title": "📅 Tip: Calendar Colors",
  "mgmt.sys.tip_calendar.desc": "Assign a different calendar color to each family member to easily tell events apart.",
  "mgmt.sys.tip_map.title": "🗺️ Tip: Safe Zones",
  "mgmt.sys.tip_map.desc": "Define safe zones like school or home for your kids to get notified on entries and exits.",
  "mgmt.sys.tip_finance.title": "💰 Tip: Budget Tracking",
  "mgmt.sys.tip_finance.desc": "You can review your monthly income-expense charts from the Finance page.",
  "mgmt.sys.tip_health.title": "❤️ Tip: Health Records",
  "mgmt.sys.tip_health.desc": "You can track family members' vaccinations and appointments from the Health page.",
  "mgmt.sys.tip_chat.title": "💬 Tip: Family Chat",
  "mgmt.sys.tip_chat.desc": "You can instantly message all members from the family chat room.",
  "mgmt.sys.feedback_request.title": "📝 Feedback Request",
  "mgmt.sys.feedback_request.desc": "Help us improve the app — please share your thoughts with us.",
  "mgmt.sys.survey.title": "📊 Short Survey",
  "mgmt.sys.survey.desc": "We kindly ask you to fill out the short survey we prepared for you.",
  "mgmt.sys.welcome.title": "👋 Welcome",
  "mgmt.sys.welcome.desc": "Welcome to the Family Planner family! We're here to help you.",
  "mgmt.sys.onboarding_tip.title": "🚀 Getting Started Tip",
  "mgmt.sys.onboarding_tip.desc": "We recommend checking the settings page to use the app most effectively.",
  "mgmt.sys.community.title": "🤝 Community Announcement",
  "mgmt.sys.community.desc": "Join our Family Planner user community and share your experiences.",
  "mgmt.sys.known_issue.title": "🐞 Known Issue Notice",
  "mgmt.sys.known_issue.desc": "We are working on an identified issue and it will be resolved soon.",
  "mgmt.sys.issue_resolved.title": "✅ Issue Resolved",
  "mgmt.sys.issue_resolved.desc": "The issue we previously reported has been resolved — thank you for your patience.",
  "mgmt.sys.server_migration.title": "🔄 Server Migration Notice",
  "mgmt.sys.server_migration.desc": "We are upgrading our server infrastructure for better performance.",
  "mgmt.sys.new_app_version.title": "📱  New App Version",
  "mgmt.sys.new_app_version.desc": "A new version with fresh features is now available — don't forget to update.",
  "mgmt.sys.storage_warning.title": "📦 Storage Space Warning",
  "mgmt.sys.storage_warning.desc": "Your document storage space is almost full — please check it.",
  "mgmt.sys.privacy_update.title": "🔒 Privacy Policy Update",
  "mgmt.sys.privacy_update.desc": "Our privacy policy has been updated — please review it.",
  "mgmt.sys.terms_update.title": "📄 Terms of Service Update",
  "mgmt.sys.terms_update.desc": "Our terms of service have been updated.",
  "mgmt.sys.holiday_closure.title": "🏖️ Holiday Period Notice",
  "mgmt.sys.holiday_closure.desc": "Our support team will operate with limited hours during the official holiday.",
  "mgmt.sys.weather_alert.title": "🌦️ Weather Alert",
  "mgmt.sys.weather_alert.desc": "Adverse weather conditions are expected in your area — please be careful.",
  "mgmt.sys.family_milestone.title": "🏆 Family Milestone",
  "mgmt.sys.family_milestone.desc": "Your family has built a great habit by using the app regularly — congratulations!",
  "mgmt.sys.invite_friends.title": "📨 Invite Friends",
  "mgmt.sys.invite_friends.desc": "Share Family Planner with your loved ones and help them organize their families too.",
  "mgmt.sys.rate_app.title": "⭐ Rate the App",
  "mgmt.sys.rate_app.desc": "If you're enjoying the app, please don't forget to rate us on the store.",
  "mgmt.sys.new_integration.title": "🔗 New Integration",
  "mgmt.sys.new_integration.desc": "A new integration has been added to our app — why not check it out?",
  "mgmt.sys.seasonal_tip.title": "🍂 Seasonal Reminder",
  "mgmt.sys.seasonal_tip.desc": "With the change of season, we recommend reviewing your family calendar.",
  "mgmt.sys.back_to_school.title": "🎒 Back to School Reminder",
  "mgmt.sys.back_to_school.desc": "Don't forget to update your calendar and tasks for the back-to-school period.",
  "mgmt.sys.daylight_saving.title": "🕐 Daylight Saving Notice",
  "mgmt.sys.daylight_saving.desc": "Daylight saving time has started — please check your calendar events.",
  "mgmt.sys.subscription_expired.title": "⏰ Subscription Expired",
  "mgmt.sys.subscription_expired.desc": "Your premium subscription has expired and feature access is now limited.",
  "mgmt.sys.payment_failed.title": "⚠️ Payment Issue",
  "mgmt.sys.payment_failed.desc": "Your last payment attempt failed — please update your payment details.",
  "mgmt.sys.new_help_center.title": "❓ Help Center Updated",
  "mgmt.sys.new_help_center.desc": "Our frequently asked questions and help content have been updated.",
  "mgmt.sys.data_export_ready.title": "📤 Data Export Ready",
  "mgmt.sys.data_export_ready.desc": "Your requested data export has been completed.",
  "mgmt.sys.general_thanks_loyal.title": "🙏 Thank You Loyal Users",
  "mgmt.sys.general_thanks_loyal.desc": "We sincerely thank you for being with us for so long.",
  "mgmt.notif.untitled": "Untitled notification",
  "mgmt.notif.untitledSys": "Untitled system announcement",
  "mgmt.notif.untitledAuto": "Automatic Notification Run",
  "mgmt.notif.familyMember": "Family Member",
  "mgmt.notif.noUserInfo": "No user info",
  "mgmt.notif.sendBtn": "🔔 Send Family Notification",
  "mgmt.notif.closeBtn": "Close Panel",
  "mgmt.notif.scheduledOpen": "⏰ Scheduled Notifications",
  "mgmt.notif.scheduledClose": "⏰ Close Scheduled Notifications",
  "mgmt.notif.searchPlaceholder": "Search by name, role, username or email",
  "mgmt.notif.titlePlaceholder": "E.g. Family Announcement",
  "mgmt.notif.bodyPlaceholder": "Write the family message to send...",
  "mgmt.notif.sending": "Sending...",
  "mgmt.notif.scheduledCreated": "Scheduled family notification created ✓",
  "mgmt.notif.sendFailed": "Family notification could not be sent.",
  "mgmt.notif.minOneUser": "Select at least one family member.",
  "mgmt.notif.titleRequired": "Title and message cannot be empty.",
  "mgmt.notif.dateRequired": "Select a date and time for scheduled notification.",
  "mgmt.notif.updateFailed": "Scheduled notification could not be updated.",
  "mgmt.notif.cancelFailed": "Scheduled notification could not be cancelled.",
  "mgmt.notif.history": "🕘 Notification History",
  "mgmt.notif.historyStatus": "Status:",
  "mgmt.notif.historySent": "Sent:",
  "mgmt.sys.open": "📢 Send System Announcement to All Users",
  "mgmt.sys.close": "📢 Close System Announcement",
  "mgmt.sys.titlePlaceholder": "E.g. Planned Maintenance",
  "mgmt.sys.bodyPlaceholder": "Write the system announcement to send to all users...",
  "mgmt.sys.titlePlaceholderEn": "Ex: Planned Maintenance Announcement",
  "mgmt.sys.bodyPlaceholderEn": "Write the English version of the announcement...",
  "mgmt.sys.templateAutoTranslate": "✅ Template selected — this notification will be automatically sent to each user in their own app language (TR/EN).",
  "mgmt.sys.fillEnglishHint": "You're writing free text. Please also fill in the English translation so users with the app set to English receive it in the correct language.",
  "mgmt.sys.noEnglishWarning": "⚠️ English fields are empty — this announcement will currently be sent only in the language above (Turkish), and English-language users will see this same text too.",
  "mgmt.sys.langBreakdown": "Language split (TR · EN)",
  "mgmt.auto.open": "⚙️ Automatic Notification Rules",
  "mgmt.auto.close": "⚙️ Close Automatic Notification Rules",
  "mgmt.auto.runNow": "▶️ Check Automatic Notifications Now",
  "mgmt.auto.running": "Checking...",
  "mgmt.auto.loading": "Loading...",
  "mgmt.auto.refresh": "Refresh",
  "mgmt.premium.open": "▾ Open",
  "mgmt.premium.close": "▴ Close",
  "mgmt.premium.on": "🟢 Premium system ON",
  "mgmt.premium.off": "🔴 Premium system OFF",
  "mgmt.premium.activeDesc": "Restrictions active — free users will encounter limits",
  "mgmt.premium.inactiveDesc": "Restrictions disabled — all users have unlimited access",
  "mgmt.premium.locked": "🔒 Premium only",
  "mgmt.premium.open2": "✅ Open to all",
  "mgmt.premium.lockedLabel": "Locked",
  "mgmt.premium.openLabel": "Open",
  "mgmt.premium.saveBtn": "💎 Save Premium Settings",
  "mgmt.premium.saving": "Saving...",
  "mgmt.limit.shopping": "Shopping items",
  "mgmt.limit.task": "Active tasks",
  "mgmt.limit.calendar": "Monthly calendar events",
  "mgmt.limit.finance": "Monthly finance records",
  "mgmt.limit.health": "Health records (per person)",
  "mgmt.limit.children": "Child profiles",
  "mgmt.limit.documents": "Document count",
  "mgmt.limit.messages": "Chat history",
  "mgmt.limit.mapPlaces": "Saved places",
  "mgmt.limit.members": "Family member count",
  "mgmt.limit.userFamilies": "User family count",
  "mgmt.limit.plusMembers": "Premium Plus total member limit",
  "mgmt.limit.mealSuggestion": "Daily meal suggestions",
  "mgmt.limit.liveLocation": "Map — Live location",
  "mgmt.limit.locationHistory": "Map — Location history",
  "mgmt.limit.petProfile": "Children — Pet profile",
  "mgmt.limit.weeklyMenu": "MealSug — Weekly menu",
  "mgmt.limit.multiRoom": "Chat — Multiple rooms",
  "mgmt.limit.scheduledNotif": "Notification — Scheduled",
  "mgmt.limit.multiFamily": "General — Multiple families",
  "mgmt.notif.selfAdmin": "Family admin cannot disable their own Home and Management access.",
  "mgmt.notif.sysAdminPanel": "Push notification system management panel.",
  "mgmt.notif.familyPanel": "You can send custom notifications to your family.",
  "mgmt.notif.testBtn": "🧪 Send Test Notification",
  "mgmt.notif.testSending": "Sending...",
  "mgmt.notif.userSearch": "Search by name, email, username or phone",
  "mgmt.notif.userTitlePh": "E.g. Check your calendar",
  "mgmt.notif.userBodyPh": "Write the message to send...",
  "mgmt.role.familyMember": "Family Member",
  "mgmt.limit.unit.item": "items",
  "mgmt.limit.unit.task": "tasks",
  "mgmt.limit.unit.perMonth": "/month",
  "mgmt.limit.unit.perPerson": "/person",
  "mgmt.limit.unit.profile": "profiles",
  "mgmt.limit.unit.doc": "docs",
  "mgmt.limit.unit.message": "messages",
  "mgmt.limit.unit.place": "places",
  "mgmt.limit.unit.member": "members",
  "mgmt.limit.unit.family": "families",
  "mgmt.limit.unit.perDay": "/day",


  "mgmt.auto.onlyPending": "Only if pending records exist",
  "mgmt.auto.oncePerDay": "Once per day per user",
  "mgmt.auto.dueToday": "Due today",
  "mgmt.auto.dueTomorrow": "Due tomorrow",
  "mgmt.auto.threeDays": "3 days left",
  "mgmt.auto.thirtyDays": "30 days left",
  "mgmt.auto.tenDays": "10 days left",
  "mgmt.auto.fiveDays": "5 days left",
  "mgmt.auto.expired": "Expired",
  "mgmt.auto.medicines": "Medicines",
  "mgmt.auto.timepolicy": "Time policy",
  "mgmt.premium.savedOk": "✓ Premium settings saved",
  "mgmt.premium.saveError": "Save error",
  "mgmt.premium.defaultsLoaded": "Default values loaded. Don't forget to save.",
  "mgmt.sched.loadFailed": "Scheduled notifications could not be loaded.",
  "mgmt.sched.updatedOk": "Scheduled notification updated ✓",
  "mgmt.sched.updateFailed": "Scheduled notification could not be updated.",
  "mgmt.sched.cancelledOk": "Scheduled notification cancelled ✓",
  "mgmt.sched.cancelFailed": "Scheduled notification could not be cancelled.",
  "mgmt.sched.deletedOk": "Scheduled notification deleted ✓",
  "mgmt.sched.deleteFailed": "Scheduled notification could not be deleted.",
  "mgmt.sched.createdOk": "Scheduled notification created ✓",
  "mgmt.sched.createFailed": "Scheduled notification could not be created.",
  "mgmt.sched.confirmCancel": "Cancel this scheduled notification?",
  "mgmt.sched.confirmDelete": "Permanently delete this scheduled notification? This cannot be undone.",
  "mgmt.auto.loadFailed": "Automatic notification rules could not be loaded.",
  "mgmt.auto.ruleFailed": "Rule could not be updated.",
  "mgmt.auto.optionFailed": "Rule option could not be updated.",
  "mgmt.auto.runFailed": "Automatic notifications could not be run.",
  "mgmt.auto.repeatFailed": "Recurring system announcement could not be updated.",
  "mgmt.auto.quietSavedOk": "Global quiet hours policy saved ✓",
  "mgmt.auto.policyFailed": "Notification policy could not be saved.",
  "mgmt.auto.defaultsOk": "Default notification policies loaded ✓",
  "mgmt.auto.defaultsFailed": "Default policies could not be set.",
  "mgmt.auto.confirmReset": "Reset all notification automation to default time policies?",
  "mgmt.sys.superAdminOnly": "This action can only be performed by a super admin.",
  "mgmt.sys.sendFailed": "System announcement could not be sent.",
  "mgmt.sys.security.title": "Security Information",
  "mgmt.sys.security.desc": "Keep your information up to date and never share your password with anyone.",
  "mgmt.notif.adminNotFound": "Admin user information not found.",
  "mgmt.notif.historyFailed": "Notification history could not be loaded.",
  "mgmt.notif.testTitle": "🧪 Test Notification",
  "mgmt.notif.testDesc": "Family Planner notification system is working correctly.",
  "mgmt.notif.testOk": "Test notification sent ✓",
  "mgmt.notif.testFailed": "Test notification could not be sent.",
  "mgmt.mail.title": "Email System and Usage Analytics",
  "mgmt.mail.desc": "Monitor Brevo primary delivery, Resend fallback, and daily usage.",
  "mgmt.mail.targetLabel": "Target email (leave empty to send to your own address)",
  "mgmt.mail.targetPh": "example@aileyonetimi.com",
  "mgmt.mail.targetHint": "The test verifies the primary provider and automatic fallback when required.",
  "mgmt.mail.testBtn": "📧 Send Test Email",
  "mgmt.mail.testSending": "Sending...",
  "mgmt.mail.testOk": "Test email sent ✓",
  "mgmt.mail.testFailed": "Test email could not be sent",
  "mgmt.mail.metricsFailed": "Email metrics could not be loaded.",
  "mgmt.mail.rangeLabel": "Statistics time range",
  "mgmt.mail.today": "Today",
  "mgmt.mail.7days": "7 days",
  "mgmt.mail.30days": "30 days",
  "mgmt.mail.refresh": "Refresh",
  "mgmt.mail.sentToday": "Sent today",
  "mgmt.mail.rangeTotal": "Selected range total",
  "mgmt.mail.dayUnit": "days",
  "mgmt.mail.activeProvider": "Active provider",
  "mgmt.mail.gatewayHealthy": "Primary gateway is healthy",
  "mgmt.mail.circuitOpen": "Brevo is temporarily unavailable; fallback is active",
  "mgmt.mail.remaining": "safe capacity",
  "mgmt.mail.fallback": "Fallback",
  "mgmt.mail.failed": "Failed",
  "mgmt.mail.failedAttempts": "Failed provider attempts",
  "mgmt.mail.undeliveredShort": "ultimately undelivered",
  "mgmt.mail.chartTitle": "Provider delivery distribution",
  "mgmt.mail.chartHint": "Emails accepted in the selected period",
  "mgmt.mail.accepted": "accepted",
  "mgmt.mail.failureHeading": "Failed attempt details",
  "mgmt.mail.failureHint": "This is not a count of lost user emails. If the primary provider rejects a request and the fallback delivers it, both a failed attempt and a recovered delivery are recorded.",
  "mgmt.mail.recovered": "delivered through fallback",
  "mgmt.mail.undelivered": "could not be delivered by either provider",
  "mgmt.mail.categoryPerformance": "Performance alert",
  "mgmt.mail.categoryPasswordReset": "Password reset",
  "mgmt.mail.categoryVerification": "Email verification",
  "mgmt.mail.categoryAdminTest": "Admin test",
  "mgmt.mail.categorySystem": "System email",
  "mgmt.mail.testHeading": "End-to-end delivery test",
  "mgmt.notif.userFamilyNotFound": "User or family information not found.",
  "mgmt.notif.familyAnnouncementTitle": "👨‍👩‍👧‍👦 Family Announcement",
  "mgmt.notif.familyAnnouncementBody": "There's a new update for your family. Please check the app.",
  "mgmt.notif.copiedToForm": "Last notification copied to form. Press Send to resend.",
  "mgmt.notif.sendToSelected": "Send to {n} Selected User(s)",

  "health.lbl.branch": "🏥 Branch",
  "health.lbl.type": "📌 Type",
  "health.lbl.location": "📍 Location",
  "health.lbl.date": "🗓️ Date",
  "health.lbl.note": "📝 Note",
  "health.lbl.measureType": "🩺 Type",
  "health.lbl.value": "📊 Value",
  "health.lbl.context": "🍽️ Context",
  "health.lbl.allergyType": "🏷️ Type",
  "health.lbl.severity": "⚠️ Severity",
  "health.lbl.symptoms": "🤒 Symptoms",
  "health.lbl.action": "✅ Action",
  "health.lbl.avoid": "🚫 Avoid",
  "health.lbl.diagnosisDate": "📅 Diagnosis",
  "health.lbl.doctor": "👨‍⚕️ Doctor",
  "health.lbl.followUp": "🔁 Follow-up",
  "health.lbl.medicines": "💊 Medicines",
  "health.lbl.blood": "🩸 Blood",
  "health.lbl.person": "👤 Person",
  "health.lbl.relation": "👨‍👩‍👧 Relation",
  "health.lbl.phone": "📞 Phone",
  "health.lbl.allergy": "⚠️ Allergy",
  "health.lbl.condition": "🫀 Condition",
  "health.lbl.medicine": "💊 Medicine",
  "health.lbl.category": "🏷️ Category",
  "health.lbl.reportType": "📄 Type",
  "health.lbl.institution": "🏥 Institution",
  "health.lbl.summary": "📌 Summary",
  "health.prof.height": "Height",
  "health.prof.weight": "Weight",
  "health.prof.chronicDiseases": "Chronic Conditions",
  "health.prof.regularMedicines": "Regular Medicines",
  "health.prof.surgeries": "Past Surgeries",
  "health.prof.specialCondition": "Disability / Special Condition",
  "health.prof.smokingAlcohol": "Smoking / Alcohol",
  "health.prof.familyDoctor": "Family Doctor",
  "health.prof.preferredHospital": "Preferred Hospital",
  "health.prof.emergencyPerson": "Emergency Contact",
  "health.prof.emergencyRelation": "Relationship",
  "health.prof.emergencyPhone": "Emergency Phone",
  "health.prof.notes": "Notes",
  "health.noAge": "No age",
  "health.userFallback": "User",
  "health.saveFailed": "Health information could not be saved.",
  "health.noPermission": "You don't have permission to add records to this health card.",
  "health.invalidMedTime": "Enter at least one valid medicine time. E.g. 08:00, 20:00",
  "health.placeholder.allergy": "Select or type allergy name",
  "health.placeholder.condition": "Select or type chronic condition",
  "health.placeholder.vaccine": "Select or type vaccine name",

  "profile.tab.info": "Info",
  "profile.tab.edit": "Edit",
  "profile.tab.password": "Password",
  "profile.fullName": "👤 Full Name",
  "profile.username": "🔖 Username",
  "profile.email": "📧 Email",
  "profile.nameRequired": "Name and surname cannot be empty.",
  "profile.updatedOk": "Profile updated ✓",
  "profile.updateFailed": "Update failed.",
  "profile.fillAll": "Fill in all fields.",
  "profile.passwordMinChars": "New password must be between 8 and 128 characters.",
  "profile.passwordMismatch": "Passwords do not match.",
  "profile.passwordUpdatedOk": "Password updated ✓",
  "settings.family.copied": "Family invite info copied.",
  "settings.notifications.saveFailed": "Notification setting could not be saved.",
  "settings.notifications.pushActivated": "Push notifications active! ✓",
  "settings.notifications.permissionDenied": "Notification permission is off. Tap the switch again to enable it.",
  "settings.notifications.openSystemSettings": "System settings opened so you can enable notifications.",
  "notification.permissionOn": "Notification permission on",
  "notification.permissionOff": "Notification permission off",
  "notification.permissionAction": "Enable",
  "settings.notifications.savedOk": "Notification settings saved ✓",
  "home.managePlans": "Manage your plans",
  "home.familyHealth": "Family health cards",
  "home.mapSub": "Locations and shared places",
  "home.childrenSub": "Growth, education and routines",
  "home.cookingSub": "Meal suggestion",
  "home.family": "My Family",
  "home.familyMembers": "family members",
  "home.managementSub": "User Management / Family Notifications",
  "home.newMessages": "New Messages",
  "home.unreadMessages": "Unread Messages",
  "children.nameRequired": "Profile name cannot be empty.",
  "children.newborn": "Newborn",
  "children.monthsOld": "months old",
  "children.yearsOld": "years old",
  "children.months": "months",
  "children.placeholder.chronic": "Chronic conditions / diseases",
  "children.placeholder.medicines": "Regular medicines",
  "children.placeholder.milestone": "Development milestone",
  "children.placeholder.education": "Record type: homework, exam...",
  "documents.nameRequired": "Document name cannot be empty.",
  "documents.fileRequired": "No file selected.",
  "documents.uploadFailed": "Upload failed",
  "chat.premium.history": "Chat history",
  "chat.premium.historyFull": "Full chat history view",
  "chat.premium.mediaHistory": "In-chat media and file history",

  "finance.confirmDelete": "Are you sure you want to delete this record?",
  "finance.savings.reminderTitle": "💰 Savings Reminder",
  "finance.alert.highExpense": "This month's expenses exceeded 85% of income. Consider reviewing your spending.",
  "finance.alert.insufficientData": "Enough data has started forming to analyze your financial balance this period.",
  "health.confirmDelete": "Delete this health record?",
  "health.defaultReport": "Health report",
  "health.notifLoading": "Opening notifications...",
  "health.notifOpen": "🔔 Enable Health Notifications",
  "health.vaultDoc": "Document vault health file",
  "health.critical": "critical records",
  "common.edit": "Edit",
  "children.confirmDelete": "Delete this record?",
  "children.memoryPhoto": "Memory photo",
  "children.memory": "Memory",
  "documents.lbl.category": "📁 Category",
  "documents.lbl.owner": "👤 Owner",
  "documents.lbl.uploader": "📤 Uploaded by",
  "documents.lbl.added": "🗓️ Added",
  "documents.lbl.expiry": "⏰ Expiry",
  "documents.upload": "Upload",
  "documents.premium.storageLimit": "Document storage MB limit",
  "documents.premium.b1": "Higher document storage space",
  "documents.premium.b2": "Large file uploads",
  "documents.premium.b3": "Store all family documents in one place",
  "documents.premium.b4": "Unlimited document version history",
  "chat.selectMembers": "Select Members",
  "chat.roomMembers": "Chat Room Members",
  "chat.removeMember": "Remove member",

  /* ── Cooking page extended ── */
  "cooking.title": "What to Cook Today?",
  "cooking.sub": "A personalized dinner suggestion for you",
  "cooking.empty": "Tap Create Menu,\nlet me suggest one for you!",
  "cooking.loading": "Preparing menu…",
  "cooking.main": "Main Dish",
  "cooking.soup": "Soup / Starter",
  "cooking.salad": "Salad / Appetizer",
  "cooking.tapRecipe": "Tap to view recipe",
  "cooking.like": "Liked it",
  "cooking.dislike": "Didn’t like it",
  "cooking.savedLike": "✓ Saved! Enjoy your meal 🎉",
  "cooking.savedDislike": "✓ Saved. It will be suggested less next time.",
  "cooking.create": "Create Menu",
  "cooking.another": "Get Another Suggestion",
  "cooking.liked": "liked",
  "cooking.dislikedMenu": "disliked menus",
  "cooking.ingredients": "Ingredients",
  "cooking.steps": "Instructions",
  "cooking.prepTime": "Prep",
  "cooking.cookTime": "Cooking",
  "cooking.totalTime": "Total",
  "cooking.difficulty": "Difficulty",
  "cooking.difficulty.easy": "Easy",
  "cooking.difficulty.medium": "Medium",
  "cooking.difficulty.hard": "Advanced",
  "cooking.tips": "Cook's Tips",
  "cooking.substitutions": "Substitutions",
  "cooking.foodSafety": "Safe Cooking",
  "cooking.storage": "Storage and Reheating",
  "cooking.allergens": "Allergen Information",
  "cooking.noDeclaredAllergens": "No common allergen is declared in this recipe. Always check product labels.",
  "cooking.recipeMissing": "No recipe information has been prepared for this recipe.",
  "cooking.closeRecipe": "Close recipe",
  "cooking.openRecipe": "Open recipe",
  "cooking.dailySuggestions": "Daily suggestions",
  "cooking.curatedMenus": "thoughtfully paired menus",
  "cooking.cultureMatched": "Made for your table",
  "cooking.catalogAria": "Menu catalogue information",
  "cooking.threeCourse": "3-course dinner",
  "cooking.source.daily": "Today's menu",
  "cooking.source.suggestion": "Fresh suggestion",
  "cooking.source.liked": "A menu you liked",
  "cooking.source.recent": "From your recents",
  "cooking.source.planned": "From your weekly plan",
  "cooking.backToDaily": "Return to today's menu",
  "cooking.yourTaste": "Picked by your taste",
  "cooking.likedMenus": "Menus you liked",
  "cooking.pickAgain": "Worth another look",
  "cooking.recentMenus": "Recently viewed",
  "cooking.openMenu": "view menu",
  "cooking.smartFilters": "Smart menu filters",
  "cooking.filtersHint": "Personalize by time, difficulty and taste",
  "cooking.filtersActive": "New suggestions will follow your active preferences",
  "cooking.filter.mainType": "Menu preference",
  "cooking.filter.maxTime": "Maximum time",
  "cooking.filter.difficulty": "Difficulty",
  "cooking.filter.all": "All",
  "cooking.filter.minutes": "{{count}} min",
  "cooking.filter.type.all": "All menus",
  "cooking.filter.type.meat": "Meat",
  "cooking.filter.type.chicken": "Chicken",
  "cooking.filter.type.fish": "Fish",
  "cooking.filter.type.vegetarian": "Meat-free",
  "cooking.filter.seasonal": "Keep it seasonal",
  "cooking.filter.seasonalHint": "Prioritizes seasonal dishes while keeping year-round favourites",
  "cooking.filter.allergens": "Allergens to exclude",
  "cooking.filter.excludeIngredients": "Ingredients you do not want",
  "cooking.filter.excludePlaceholder": "e.g. mushrooms, celery, garlic",
  "cooking.filter.noMatch": "No menu matches these preferences. Try removing one filter.",
  "cooking.filter.matchCount": "{{count}} suitable menus ready",
  "cooking.filter.reset": "Reset filters",
  "cooking.weeklyPlan": "Weekly meal plan",
  "cooking.weeklyPlanHint": "Place favourite menus onto days of the week",
  "cooking.weeklyPlanPremiumDesc": "Plan dinners ahead by placing menus onto the days of your week.",
  "cooking.weeklyBenefit1": "A seven-day dinner plan",
  "cooking.weeklyBenefit2": "Place menus onto days with one tap",
  "cooking.weeklyBenefit3": "Quick access to planned recipes",
  "cooking.weeklyBenefit4": "Works together with your shopping list",
  "cooking.selectedDay": "Selected day",
  "cooking.dayNotPlanned": "No menu has been planned for this day",
  "cooking.planCurrentMenu": "Plan this menu",
  "cooking.clearPlannedDay": "Remove the selected day's menu",
  "cooking.servingUnit": "servings",
  "cooking.servingSize": "Serving size",
  "cooking.decreaseServing": "Decrease servings",
  "cooking.increaseServing": "Increase servings",
  "cooking.addIngredientsShopping": "Send ingredients to shopping",
  "cooking.chooseMissingIngredients": "Choose what you need and add it to the family list",
  "cooking.selectedIngredients": "{{count}} ingredients selected",
  "cooking.selectAll": "Select all",
  "cooking.clearSelection": "Clear",
  "cooking.addSelectedShopping": "Add {{count}} ingredients to the list",
  "cooking.addingShopping": "Adding to the shopping list…",
  "cooking.shoppingAdded": "{{count}} ingredients were added to the shopping list.",
  "cooking.openShoppingList": "Open list",
  "cooking.shoppingAddFailed": "The ingredients could not be added. Please try again.",
  "cooking.premium.b1": "Unlimited daily menu suggestions",
  "cooking.premium.b2": "Weekly menu plan",
  "cooking.premium.b3": "Like-based personalization",
  "cooking.premium.b4": "Suggestions based on family preferences",

  /* ── Shared component labels ── */
  "common.showLess": "Show less",
  "common.showMore": "More",
  "common.showAll": "Show all",
  "common.now": "Now",
  "footer.title": "Your Family Tracking App © 2026",
  "footer.dev": "Developed by Sercan YAVUZ.",
  "finance.summaryTitle": "Overall Financial Status",
  "finance.privacy.show": "Show amounts",
  "finance.privacy.hide": "Hide amounts",
  "finance.netBalancePeriod": "Net balance this period",
  "finance.balanced": "Balanced",
  "finance.deficit": "Deficit",
  "finance.transaction": "Transaction",
  "notif.type.chat": "Chat",
  "notif.type.task": "Task",
  "notif.type.reminder": "Reminder",
  "notif.type.shopping": "Shopping",
  "notif.type.calendar": "Calendar",
  "notif.type.finance": "Finance",
  "notif.type.expense": "Expense",
  "notif.type.document": "Document",
  "notif.type.health": "Health",
  "notif.type.medicine": "Medicine",
  "notif.type.appointment": "Appointment",
  "notif.type.birthday": "Birthday",
  "notif.type.location": "Location",
  "notif.type.family": "Family",
  "notif.type.familyStatus": "Family Status",
  "notif.type.system": "System",
  "notif.type.scheduled": "Scheduled",
  "notif.type.assistant": "Family Assistant",
  "notif.type.children": "Child Tracker",
  "notif.type.default": "Notification",

  /* ── Premium Limits ── */
  "premium.limitReached": "{{label}} limit reached",
  "premium.limitDescGeneric": "On the free plan, you can use up to {{max}} {{label}}",
  "premium.limit.shoppingItems": "shopping items",
  "premium.limit.activeTasks": "active tasks",
  "premium.limit.documents": "documents",
  "premium.limit.financeRecords": "finance records",
  "premium.benefit.multiFamily": "Multiple family groups",
  "premium.benefit.separatePlanning": "Separate planning for each family",
  "premium.benefit.quickSwitch": "Quick switching between families",
  "premium.benefit.unlimitedTasks": "Unlimited active tasks (free plan: 10 limit)",
  "premium.benefit.taskPriority": "Priority and category support",
  "premium.benefit.taskReminders": "Task reminders",
  "premium.plus.benefit.shoppingSync": "Separate lists in all family groups",
  "premium.plus.benefit.shoppingAssign": "Per-person item assignment",
  "premium.plus.benefit.shoppingBudget": "Unlimited items across 10 families",
  "premium.plus.benefit.taskAssign": "Task assignment and tracking",
  "premium.plus.benefit.taskRepeat": "Separate task lists across 10 families",
  "premium.plus.benefit.taskStats": "3-member family limit removed",
  "premium.plus.benefit.docsUnlimited": "Unlimited documents and storage",
  "premium.plus.benefit.docsVersioning": "Separate folders across 10 families",
  "premium.plus.benefit.docsTeam": "Sharing with unlimited family members",
  "premium.plus.benefit.financeMulti": "Multi-family finance tracking",
  "premium.plus.benefit.financeAdvanced": "Separate finance tracking in 10 families",
  "premium.plus.benefit.financeExport": "Shared expenses with unlimited members",
  "premium.benefit.unlimitedShopping": "Unlimited shopping list",
  "premium.benefit.shoppingCategories": "Custom shopping categories",
  "premium.benefit.shoppingHistory": "Purchased items history",
  "premium.benefit.unlimitedDocuments": "Unlimited document uploads",
  "premium.benefit.personalSharedDocs": "Personal and shared documents",
  "premium.benefit.expiryTracking": "Expiry date tracking",
  "premium.benefit.unlimitedMonthlyRecords": "Unlimited monthly records",
  "premium.benefit.reportsCharts": "Reports and charts",
  "premium.benefit.savingsGoals": "Savings goals",
  "premium.benefit.installmentSubscriptions": "Installment and subscription tracking",

  /* ── Reminder Panel ── */
  "reminder.set": "Set reminder",
  "reminder.once": "Once",
  "reminder.daily": "Every day",
  "reminder.weekly": "Every week",
  "reminder.monthly": "Every month",
  "reminder.date": "Notification Date",
  "reminder.time": "Time",
  "reminder.daysBefore": "Days Before",
  "reminder.sameDay": "Same day",
  "reminden.sameDay": "Same day",
  "reminder.daysBeforeSuffix": "days before",
  "reminder.willSend": "Notification will be sent",
  "reminder.needReferenceDate": "Enter the due / renewal date first to calculate the reminder date.",
  "reminder.invalid.missingDate": "Please choose a date for the reminder.",
  "reminder.invalid.pastDate": "A reminder cannot be set for a past date or time. Please choose a future date and time.",
  "reminder.invalid.general": "Reminder could not be created. Please choose a valid future date and time.",
  "reminder.repeat": "Repeat",

  /* ── Auth Animation Scene ── */
  "auth.scene.calendar": "Family Calendar",
  "auth.scene.calendarDesc": "All plans in one place",
  "auth.scene.tasks": "Shared Tasks",
  "auth.scene.tasksDesc": "Complete together",
  "auth.scene.finance": "Finance Tracking",
  "auth.scene.financeDesc": "Manage your budget",
  "auth.scene.documents": "Family Documents",
  "auth.scene.documentsDesc": "Store safely",
  "auth.scene.shopping": "Shopping",
  "auth.scene.shoppingDesc": "Prepare lists",
  "auth.scene.expenses": "Shared Expenses",
  "auth.scene.expensesDesc": "Fair sharing",

  /* ── Final App / Family Keys ── */
  "app.loadingSession": "Checking your session.",
  "app.loadingFamily": "Checking your family information.",
  "family.noneTitle": "Let's set up your family space",
  "family.noneDesc": "To continue, create your own family group or join an existing one with an invite code from your family.",
  "family.setupEyebrow": "Your account is ready · One last step",
  "family.setupProgressLabel": "Family setup steps",
  "family.setupStepChoose": "Choose your path",
  "family.setupStepComplete": "Complete details",
  "family.setupChooseLabel": "Family setup options",
  "family.createOptionBadge": "New group",
  "family.createOptionTitle": "I will create my family",
  "family.createOptionDesc": "Give your family a name, then invite members with a secure code.",
  "family.createOptionAction": "Start with a family name",
  "family.joinOptionBadge": "I have an invite",
  "family.joinOptionTitle": "I will join my existing family",
  "family.joinOptionDesc": "Use the invite code beginning with FP sent by your family admin.",
  "family.joinOptionAction": "Enter invite code",
  "family.createFormDesc": "Choose a short name your family members will easily recognize.",
  "family.nameLabel": "Family name",
  "family.nameHelp": "For example: The Yavuz Family, Our Home, or The Demir Family",
  "family.inviteCodeLabel": "Family invite code",
  "family.inviteCodeHelp": "Ask the person who created the family group for this code.",
  "family.wrongAccountHint": "Signed in with the wrong account?",
  "family.noFamilyDeleteTitle": "Do you want to close your account?",
  "family.noFamilyDeleteDesc": "You are no longer connected to any family group. You can permanently delete your account and personal data if you want.",
  "family.noFamilyDeleteFinalWarning": "Your account will be permanently deleted. Your profile will be anonymized, sessions will be closed, and your personal data will be cleaned. This action cannot be undone.",
  "accountDeletionSurvey.title": "Why do you want to delete your account?",
  "accountDeletionSurvey.required": "Select at least one reason to continue.",
  "accountDeletionSurvey.maxReasons": "You can select up to 5 reasons.",
  "accountDeletionSurvey.otherRequired": "Add a short note for the other reason.",
  "accountDeletionSurvey.otherPlaceholder": "Briefly tell us why",
  "accountDeletionSurvey.continue": "Continue",
  "accountDeletionSurvey.reason.setup_unclear": "I did not understand how to create a family",
  "accountDeletionSurvey.reason.expected_something_else": "I expected something different from the app",
  "accountDeletionSurvey.reason.no_family_invite": "I do not have an invite code for my family",
  "accountDeletionSurvey.reason.privacy_concern": "I have privacy or data security concerns",
  "accountDeletionSurvey.reason.too_many_steps": "The setup felt too long or complicated",
  "accountDeletionSurvey.reason.technical_problem": "I experienced a technical problem",
  "accountDeletionSurvey.reason.missing_feature": "A feature I need is missing",
  "accountDeletionSurvey.reason.just_testing": "I registered only to try the app",
  "accountDeletionSurvey.reason.not_ready": "I am not ready to use it right now",
  "accountDeletionSurvey.reason.other": "Other",
  "accountDeletionSurvey.reason.prefer_not_to_say": "I prefer not to say",
  "family.create": "Create Family",
  "family.joinByCode": "Join Family with Invite Code",
  "family.createNew": "Create New Family",
  "family.suggestedName": "{{surname}} FAMILY",
  "family.placeholderName": "E.g. Yavuz Family",
  "family.createButton": "Create Family",
  "family.join": "Join Family",
  "family.placeholderCode": "FP-XXXXXXX",
  "family.joinButton": "Join",
  "family.welcome": "Welcome 🎉",
  "family.welcomePopup.title": "Welcome! 🎉",
  "family.welcomePopup.titleCreated": "Your Family is Ready! 🎉",
  "family.welcomePopup.subtitle": "{{familyName}} is now your family.",
  "family.welcomePopup.feature1": "Track when your children arrive at or leave school, home, and important places you define, with instant notifications.",
  "family.welcomePopup.feature2": "Record your child’s or baby’s development regularly and continuously follow growth and important milestones.",
  "family.welcomePopup.feature3": "Track income, expenses, savings, installments, subscriptions, and bills clearly from one place.",
  "family.welcomePopup.feature4": "Family Assistant follows your family data, identifies priorities, and keeps you informed with helpful suggestions.",
  "family.welcomePopup.feature5": "Track personal and shared family documents and receive timely notifications when expiry dates approach or pass.",
  "family.welcomePopup.feature6": "Create random daily menus, discover new ideas, and leave the “What should I cook today?” question behind.",
  "family.welcomePopup.feature7": "Manage a shared shopping list together, scan a list with your camera to add items quickly, and track purchased items instantly.",
  "family.welcomePopup.feature8": "Track shared expenses with ease, scan receipts to record spending quickly, and clearly see who paid and who owes.",
  "family.welcomePopup.cta": "Let's Get Started!",
  "tour.ariaLabel": 'App guide',
  "tour.step": 'Step {{current}} of {{total}}',
  "tour.skip": 'Skip',
  "tour.back": 'Back',
  "tour.next": 'Next',
  "tour.finish": 'Finish Tour',
  "tour.profile.title": 'Your profile is here',
  "tour.profile.text": 'Edit your personal details and avatar, change your password, and securely sign out of your account.',
  "tour.family.title": 'Manage your families here',
  "tour.family.text": 'Switch between families, create a new family, or join another family with an invite code.',
  "tour.notifications.title": 'All notifications in one place',
  "tour.notifications.text": 'Follow task, calendar, chat, shopping, location, and other family activity notifications here.',
  "tour.settings.title": 'Personalize the app',
  "tour.settings.text": 'Choose the theme, language, and default opening page; manage notifications and quiet hours. Family settings, privacy actions, legal documents, data export, location history, and account actions are also available here.',
  "tour.summary.title": "Your family's current overview",
  "tour.summary.text": 'These cards show upcoming items, key figures, and Family Assistant summaries at a glance. Swipe to see more summaries.',
  "tour.quickStats.title": 'Quick status information',
  "tour.quickStats.text": 'See Shopping status at a glance, then tap Product, Pending, or Bought counts to open the related section.',
  "tour.familyStatus.title": 'See your family status at a glance',
  "tour.familyStatus.text": 'For families with at least two members, this card shows updates such as Home, On the way, and Safe. Tap your own card to share a status; tap another member to view details or request an update. You can show or hide this card from Settings > Family.',
  "tour.modules.title": 'Every tool your family needs',
  "tour.modules.text": 'Use the home cards to access the sections available to you, including Shopping, Calendar, Finance, Tasks, Expenses, Health Data, Family Map, Child and Baby Tracking, Family Chat, Documents, What Should I Cook?, My Family, Family Activity, Management, and Family Assistant.',
  "tour.gestures.title": "Discover quick gestures",
  "tour.gestures.intro": "Use two practical swipe gestures to move around the app more quickly.",
  "tour.gestures.ariaLabel": 'Quick gestures',
  "tour.gestures.back.title": 'Go back quickly',
  "tour.gestures.back.text": 'Swipe right from the left edge on inner pages.',
  "tour.gestures.menu.title": 'Open the side menu',
  "tour.gestures.menu.text": 'Swipe left from the right edge.',
  "tour.done.title": "You're all set! 🎉",
  "tour.done.text": "You're ready to use Aile Yönetimi. Add daily plans, invite your family, and start exploring every feature.",
  "reminders.dailyTitle": "Daily Reminders",

  /* ── Final i18n completion keys ── */
  "auth.error.requiredFields": "Please fill in all required fields.",
  "auth.error.loginFailed": "Login failed. Please check your details and try again.",
  "auth.error.phoneFormat": "Phone must be in 05555555555 format.",
  "auth.error.usernameTaken": "This username is already in use.",
  "auth.error.emailTaken": "This email address is already registered.",
  "auth.error.phoneTaken": "This phone number is already in use.",
  "auth.info.verificationSent": "Verification email sent. Please check your inbox.",
  "auth.error.userNotFound": "Registered user not found.",
  "auth.error.loginRequired": "Login information and password cannot be empty.",
  "auth.error.sessionNotFound": "Session not found. Please sign in again.",
  "auth.info.verificationResent": "Verification email sent again. Check your inbox and spam folder.",
  "auth.info.emailVerified": "Email verified. Redirecting you to the app.",
  "auth.error.emailNotVerified": "Email still appears unverified. Click the link first, then check again.",
  "auth.error.resetInfoRequired": "Enter an email, username or phone for password reset.",
  "auth.info.resetSent": "Password reset link sent to the email address.",
  "auth.info.registerSuccess": "Registration successful! Click the verification link we sent to your email to activate your account.",
  "auth.verifyEmailChecking": "Verifying",
  "auth.verifyEmailCheckingSub": "Your email verification link is being checked.",
  "auth.verifyEmailSuccessSub": "You can return to the app and continue.",
  "auth.verifyEmailInvalidTitle": "Link invalid",
  "auth.verifyEmailLinkInvalid": "Verification link is invalid, already used, or expired.",
  "family.error.nameRequired": "Family name cannot be empty.",
  "family.error.codeRequired": "Enter the invite code.",
  "family.joinSuccess": "You are now a member of {{familyName}}. 👨\u200d👩\u200d👧\nWelcome to the family ❤️",
  "family.confirmLeave": "Are you sure you want to leave the family group?",
  "family.confirmLeaveOnlyAdminTitle": "Admin role will be transferred",
  "family.confirmLeaveOnlyAdmin": "You are the only admin in this family. If you leave, admin ownership will be transferred to another member and the family will continue without being deleted.",
  "family.confirmLeaveOnlyAdminButton": "Transfer & Leave",
  "family.leftAndDeleted": "You left the family group. Because you were the last member, the family and its data were deleted.",
  "family.confirmLeaveLastMemberButton": "Delete Family & Leave",
  "family.confirmLeaveLastMemberTitle": "Family will be permanently deleted",
  "family.confirmLeaveLastMember": "You are the last member of this family. If you leave this family, the family and all data belonging to it will be permanently deleted. This action cannot be undone.",
  "family.codeCopied": "Family code copied.",
  "family.permissionsSaved": "Permissions saved.",
  "family.error.ownerRemove": "The family founder cannot be removed from the family.",
  "family.confirmRemove": "Remove {{name}} from the family?",
  "family.error.noUserEmail": "This user does not have an email address.",
  "family.passwordResetSentTo": "Password reset email sent to {{email}}.",
  "chat.newMenuSuggestion": "Suggest new menu",
  "chat.sharedImageAlt": "Shared image",
  "chat.options": "Options",
  "chat.me": "Me",
  "chat.addNewMember": "+ Add New Member",
  "chat.selectPeopleToAdd": "Select people to add:",
  "chat.adding": "Adding...",
  "chat.addPeople": "✓ Add {{count}} People",
  "chat.manageMembers": "Manage members",
  "chat.addMember": "Add member",
  "chat.memberCount": "{{count}} members",
  "chat.search": "Search",
  "chat.searchInMessages": "Search messages...",
  "chat.pinnedMessage": "Pinned message",
  "chat.uploading": "{{percent}}% uploading...",
  "chat.editing": "✏️ Editing",
  "chat.media": "📎 Media",
  "chat.addMedia": "Add media",
  "chat.photo": "Photo",
  "chat.file": "File",
  "chat.mediaExpired": "This media file was removed because the 30-day storage period has expired.",
  "chat.mediaRetentionInfo": "Chat photos, files, documents and voice messages are stored for 30 days. Expired media is removed automatically.",
  "chat.audioRecord": "Voice",
  "chat.audioRecordStart": "Starting recording…",
  "chat.audioRecordCancel": "Cancel",
  "chat.audioRecordSend": "Send",
  "chat.voiceMessage": "🎤 Voice message",
  "chat.noSendPermission": "You do not have permission to send messages in this chat.",
  "chat.createQa": "Create {{label}}",
  "chat.title": "Title",
  "chat.titlePlaceholder": "{{label}} title...",
  "chat.createAndNotify": "✓ Create and Notify Chat",
  "chat.draftReadWarn": "Chat draft could not be read:",
  "chat.draftSaveWarn": "Chat draft could not be saved:",
  "chat.messageSendError": "Message could not be sent:",
  "chat.menuSuggestion": "🍽️ Menu suggestion: {{meal}}",
  "chat.freeHistoryLimit": "On the free plan, only the last {{limit}} messages are shown in this chat. Premium is required to see older messages.",
  "management.pageCount": "Pages",
  "management.actionCount": "Actions",
  "management.saveFailed": "Save failed.",
  "management.emailNotFound": "Email not found",
  "management.feature.financeReport": "Finance — Reports & charts",
  "management.feature.financeSavings": "Finance — Savings goals",
  "management.feature.financeInstallments": "Finance — Installment tracking",
  "management.feature.financeSubscriptions": "Finance — Subscription tracking",
  "management.feature.financeBills": "Finance — Bill tracking",
  "management.feature.autoNotifications": "Notifications — Automatic",
  "mgmt.repeat.once": "One-time",
  "mgmt.repeat.weekly2": "Once a Week",
  "mgmt.notify.emergencyTitle": "Emergency Family Announcement",
  "mgmt.notify.calendarTitle": "Check your calendar",
  "mgmt.notify.documentsTitle": "Check your documents",
  "mgmt.notify.generalTitle": "New announcement",
  "mgmt.rule.sameDay": "Same day",
  "mgmt.rule.daysBefore": "{{count}} days before",
  "mgmt.rule.overdue": "Overdue records",
  "mgmt.rule.expired": "Expired records",
  "mgmt.rule.weekly": "Weekly summary",
  "mgmt.error.scheduledDateRequired": "Scheduled date/time cannot be empty.",
  "mgmt.auto.runResult": "Automatic notifications checked ✓ Created: {{created}}, Push: {{sent}}, Error: {{failed}}",
  "mgmt.sys.scheduledCreated": "Scheduled system announcement created ✓ Target users: {{count}}",
  "mgmt.sys.sentToUsers": "System announcement sent to {{count}} users ✓",
  "mgmt.sys.deliveryResult": "Push sent to {{sent}} devices · {{inApp}} in-app records · {{failed}} failed",
  "mgmt.sys.pushDeliveryFailed": "Push did not reach any device. {{count}} in-app records were created.",
  "mgmt.user.sentToUsers": "Notification sent to {{count}} users ✓",
  "mgmt.family.sentToMembers": "Notification sent to {{count}} family members ✓",
  "mgmt.confirm.cancelScheduled": "Do you want to cancel this scheduled notification?",
  "mgmt.noMessage": "No message",
  "mgmt.family.scheduleSelected": "⏰ Schedule for {{count}} Selected Members",
  "mgmt.family.sendSelected": "📨 Send to {{count}} Selected Members",
  "mgmt.sys.scheduleSelected": "⏰ Schedule for {{count}} Users",
  "mgmt.sys.sendSelected": "📢 Send to {{count}} Users",
  "mgmt.auto.panelClose": "⚙️ Close Notification Automation",
  "mgmt.auto.panelOpen": "⚙️ Notification Automation",
  "service.error.noNotifyUsers": "No users found to send notifications.",
  "service.error.familyLimit": "You can be a member of up to 10 families.",
  "service.error.familyCodeNotFound": "No family found for this code.",
  "service.error.alreadyFamilyMember": "You are already a member of this family.",
  "service.error.apiReturned": "API returned an error: {{status}}",
  "service.error.storage": "Storage error: {{status}}",
  "service.error.network": "Network error",
  "service.error.cancelled": "Cancelled",
  "service.error.billNotFound": "Bill record not found",
  "service.error.userFamilyMissing": "User or family information was not found.",
  "service.error.httpsRequired": "The app must be opened over HTTPS for notifications.",
  "service.error.noServiceWorker": "This device does not support Service Worker.",
  "service.error.noWebPush": "This browser does not support Web Push.",
  "service.error.noNotification": "This browser does not support notifications.",
  "service.error.iosStandalone": "On iPhone, open the app from the icon you added to the Home Screen for notifications.",
  "service.error.permissionDenied": "Notification permission was denied.",
  "service.error.notificationSettingsUid": "Notification settings could not be saved. uid is missing.",

  /* ── Service i18n completion keys ── */
  "service.error.familySenderMissing": "Family or sender information is missing.",
  "service.error.familyCreatorMissing": "Family or creator information is missing.",
  "service.error.noFamilyMembersToSend": "No family member found to send to. Check your member selection.",
  "service.error.familyIdMissing": "familyId was not found.",
  "service.error.savingNotFound": "Savings record not found.",
  "service.error.installmentNotFound": "Installment record not found.",
  "service.error.subscriptionNotFound": "Subscription record not found.",
  "service.error.vapidInvalid": "VAPID Public Key is invalid. Expected length is 65 bytes, received: {{length}} bytes.",

  /* ── Service i18n completion keys ── */
  "service.error.uploadStatus": "Upload error: {{status}}",
  "service.error.uploadFailed": "Upload failed.",

  /* ── Final i18n cleanup ── */
  "auth.error.invalidCredentials": "Username or password is incorrect.",
  "auth.error.emailInUse": "This email is already registered.",
  "auth.error.weakPassword": "Password must be between 8 and 128 characters.",
  "auth.error.invalidEmail": "Enter a valid email address.",
  "common.genericError": "Something went wrong.",
  "common.noDeletePermission": "You do not have permission to delete this record.",
  "common.categoryAdminOnly": "Only the family manager can add categories.",
  "premium.feature.familyCreate": "Creating a family",
  "premium.feature.familyJoin": "Joining a family",
  "premium.benefit.unlimitedMonthly": "Unlimited monthly records",
  "premium.benefit.installmentsSubscriptions": "Installment and subscription tracking",
  "notif.shoppingList.title": "🛒 Shopping List",
  "notif.shoppingList.added": "{{name}} added \"{{item}}\" to the list",
  "notif.itemBought.title": "🛒 Item Bought",
  "notif.itemBought.body": "\"{{item}}\" was marked as bought",
  "notif.itemBought.by": "{{name}} marked \"{{item}}\" as bought",
  "notif.taskAssigned.title": "✅ New Task Assigned",
  "notif.taskAssigned.body": "The task \"{{task}}\" was assigned to you",
  "notif.taskCompleted.title": "✅ Task Completed",
  "notif.taskCompleted.body": "{{name}} completed the task \"{{task}}\"",
  "notif.medicineReminder.title": "💊 Medicine Reminder",
  "notif.medicineSoon.title": "💊 Medicine Time Approaching!",
  "notif.medicine1h": "{{medicine}} — in 1 hour ({{time}})",
  "notif.medicine5m": "{{medicine}} — in 5 minutes ({{time}})",

  /* ── Auto-notification keys (backend saves these as baslikKey/aciklamaKey) ── */
  "notif.auto.shopping.title": "🛒 Shopping Reminder",
  "notif.auto.shopping.body": "There are {{count}} pending items in the shopping list.",
  "notif.auto.sharedExpense.title": "💸 Expense Reminder",
  "notif.auto.sharedExpense.body": "There are {{count}} shared expense records this month. Total: {{amount}}.",
  "notif.auto.task.today.title": "🔴 Task Due Today",
  "notif.auto.task.today.body": "\"{{task}}\" must be completed today.",
  "notif.auto.task.tomorrow.title": "🟠 Task Due Tomorrow",
  "notif.auto.task.tomorrow.body": "\"{{task}}\" is due tomorrow.",
  "notif.auto.task.3days.title": "🟡 Task Reminder",
  "notif.auto.task.3days.body": "\"{{task}}\" is due in 3 days.",
  "notif.auto.task.overdue.title": "🔴 Overdue Task",
  "notif.auto.task.overdue.body": "The due date for \"{{task}}\" has passed.",
  "notif.auto.calendar.today.title": "📅 Today's Event",
  "notif.auto.calendar.tomorrow.title": "📅 Tomorrow's Event",
  "notif.auto.calendar.week.title": "📅 This Week's Event",
  "notif.auto.calendar.body": "{{event}}{{timeText}}",
  "notif.auto.calendar.timeText": " · Time: {{time}}",
  "notif.auto.document.reminder.title": "📁 Document Reminder",
  "notif.auto.document.reminder.body": "The validity date for \"{{document}}\" is approaching.",
  "notif.auto.document.expired.title": "⛔ Your Document Has Expired",
  "notif.auto.document.expired.body": "Your document \"{{document}}\" has expired. Please check it.",
  "notif.auto.document.today.title": "⚠️ Document Expires Today",
  "notif.auto.document.tomorrow.title": "⚠️ Document Expires Tomorrow",
  "notif.auto.document.days.title": "📁 {{days}} Days Left for Document",
  "notif.auto.appointment.today.title": "🏥 Today's Health Appointment",
  "notif.auto.appointment.tomorrow.title": "🏥 Health Appointment Tomorrow",
  "notif.auto.appointment.body": "Appointment for {{member}}{{timeText}}",
  "notif.auto.medicine.ending.title": "💊 Medicine Ends Today",
  "notif.auto.medicine.ending.body": "\"{{medicine}}\" ends today.",
  "notif.auto.medicine.reminder.title": "💊 Medicine Reminder",
  "notif.auto.medicine.reminder.body": "It's time to take \"{{medicine}}\". Time: {{time}}",
  "notif.auto.installment.today.title": "🧾 Installment Payment Due Today",
  "notif.auto.installment.today.body": "The installment payment for \"{{name}}\" is due today.",
  "notif.auto.installment.days.title": "🧾 Installment Payment Reminder",
  "notif.auto.installment.days.body": "The installment payment for \"{{name}}\" is due in {{days}} days.",
  "notif.auto.subscription.today.title": "🔄 Subscription Payment Due Today",
  "notif.auto.subscription.today.body": "The subscription payment for \"{{name}}\" is due today.",
  "notif.auto.subscription.days.title": "🔄 Subscription Payment Reminder",
  "notif.auto.subscription.days.body": "The subscription payment for \"{{name}}\" is due in {{days}} days.",
  "notif.auto.bill.today.title": "📋 Bill Due Today",
  "notif.auto.bill.today.body": "The bill \"{{name}}\" is due today.",
  "notif.auto.bill.days.title": "📋 Bill Payment Reminder",
  "notif.auto.bill.days.body": "The bill \"{{name}}\" is due in {{days}} days.",
  "notif.auto.birthday.title": "🎂 It's {{name}}'s Birthday Today!",
  "notif.auto.birthday.body": "Don't forget to wish {{name}} a happy birthday from the whole family! 🎉💕",
  "home.reminder.overdue": "{{days}} days overdue",
  "home.reminder.todayLast": "Last day today!",
  "home.reminder.tomorrowLast": "Last day tomorrow",
  "home.reminder.daysLeft": "{{days}} days left",
  "home.reminder.todayAt": "Today at {{time}}",
  "home.reminder.today": "Today",
  "home.reminder.tomorrow": "Tomorrow",
  "home.reminder.daysLater": "in {{days}} days",
  "home.reminder.birthday": "Birthday — {{when}}",
  "home.reminder.medicine": "Medicine",
  "home.reminder.appointment": "Appointment",
  "home.reminder.healthAppointment": "Health appointment — {{when}}{{timeText}}",
  "auto.shopping.title": "Shopping Reminder",
  "auto.shopping.desc": "Sends reminders to family members if there are pending items in the shopping list.",
  "auto.task.title": "Task Due Date Reminder",
  "auto.task.desc": "Reminds the related user about tasks due today, tomorrow, or in 3 days.",
  "auto.calendar.title": "Calendar Event Reminder",
  "auto.calendar.desc": "Notifies family members about today’s, tomorrow’s, and this week’s events.",
  "auto.document.title": "Document Expiry Reminder",
  "auto.document.desc": "Sends document validity warnings for 30, 10, 5 days, tomorrow, today, and expired documents.",
  "auto.health.title": "Health / Medicine Reminder",
  "auto.health.desc": "Sends upcoming health appointment and medicine reminders to the related family member.",

  /* ── Chat cleanup ── */
  "chat.taskCreated": "Created Task",
  "chat.shoppingAdded": "Added to Shopping List",
  "chat.calendarAdded": "Added to Calendar",
  "chat.edited": "edited",
  "chat.reply": "Reply",
  "chat.edit": "Edit",
  "chat.addMembersToRoom": "Add members to {{room}} chat",
  "chat.allMembersAlreadyInRoom": "All family members are already in this chat.",
  "chat.addSelectedMembers": "✓ Add {{count}} Member(s)",
  "chat.member": "Member",
  "chat.deleteRoomConfirm": "This chat and all messages will be permanently deleted.",

  /* ── Management cleanup ── */
  "mgmt.description": "Manage family members’ page access, action permissions, and family notifications here.",
  "mgmt.noMembers": "No family members found",
  "mgmt.permission": "Permission",
  "mgmt.familyNotify.title": "Send Notification to Family",
  "mgmt.familyNotify.desc": "This area is used only to send notifications to your own family members.",
  "mgmt.searchUser": "Search User",
  "mgmt.selectAllVisibleFamily": "Select all visible family members",
  "mgmt.selectedFamilyCount": "Selected family member: {{selected}} / Total family member: {{total}}",
  "mgmt.noFamilySearch": "No family member matched your search.",
  "mgmt.familyTemplates": "Ready Message Cards for Family",
  "mgmt.title": "Title",
  "mgmt.sendType": "Send Type",
  "mgmt.sendTime": "Send Time",
  "mgmt.noFamilyNotif": "No family notification has been sent yet.",
  "mgmt.resend": "Resend",
  "mgmt.noScheduledFamily": "No scheduled family notification found.",
  "mgmt.cancel": "Cancel",
  "mgmt.notifManagement": "Notification Management",
  "mgmt.userNotify": "Send Notification to User",
  "mgmt.selectAllVisibleUsers": "Select all visible users",
  "mgmt.selectedUserCount": "Selected user: {{selected}} / Total user: {{total}}",
  "mgmt.onlyFamily": "This notification is sent only to your own family members.",
  "mgmt.selectedFamilyOnly": "Selected family member: {{count}}",
  "mgmt.templates": "Ready Message Cards",
  "mgmt.globalIndependent": "This area is independent from the send notification to user section.",
  "mgmt.totalUsers": "Total registered users in the system: {{count}}",
  "mgmt.systemTemplates": "Ready System Announcement Cards",
  "mgmt.cronInfo": "GitHub cron runs every hour; this panel manages which automatic notifications the cron will run.",
  "mgmt.lastRun": "Last run: {{date}}",
  "mgmt.sentError": "Sent: {{sent}} · Error: {{error}}",
  "mgmt.activeRecords": "{{count}} active records",
  "mgmt.noAutomationLog": "No automatic notification run record yet.",
  "mgmt.createdPushError": "Created: {{created}} · Push: {{push}} · Error: {{error}}",
  "mgmt.created": "Created: {{created}}",
  "mgmt.pushLabel": "Push",
  "mgmt.errorLabel2": "Error",
  "mgmt.policyDesc": "Manage system notification times, day policy, quiet hours, and daily limits here without changing users’ notification preferences.",
  "mgmt.quietStart": "Quiet hours start",
  "mgmt.localTimeHint": "These times are applied in each user's local time.",
  "mgmt.quietEnd": "Quiet hours end",
  "mgmt.cronInterval": "Cron check interval",
  "mgmt.resetDefaults": "Reset to Default",
  "mgmt.dailyLimit": "Daily limit",
  "mgmt.ruleName": "Rule name",
  "mgmt.daysBefore": "Days before",
  "mgmt.deliveryTime": "Delivery time",
  "mgmt.deleteRule": "Delete Rule",
  "mgmt.addDayRule": "+ Add new day rule",
  "mgmt.scheduledInfo": "Manage pending notifications stored in the backend scheduled_notifications table here.",
  "mgmt.recurring": "Recurring",
  "mgmt.noScheduledFilter": "No pending scheduled notification matches this filter.",
  "mgmt.noHistory": "Notification history not found.",
  "mgmt.premiumSettings": "Premium Settings",
  "mgmt.premiumDesc": "Free user limits and locked feature management",
  "mgmt.freeLimits": "Free Plan Limits",
  "mgmt.freeLimitsDesc": "Maximum values free users can reach.",
  "mgmt.default": "default",
  "mgmt.lockedFeatures": "Locked Features",
  "mgmt.lockedDesc": "Locked = only premium users can access.",
  "mgmt.resetPremiumDefaults": "Reset to Default Values",
  "mgmt.limit.geofence": "Map — Geofence",

  /* ── Chat menu cleanup ── */
  "chat.menuSuggestionTitle": "Menu Suggestion",
  "chat.mainDish": "Main Dish",
  "chat.soup": "Soup",
  "chat.saladMeze": "Salad / Appetizer",

  /* ── Notification policy cleanup ── */
  "policy.global.title": "General Notification Policy",
  "policy.shopping.title": "Shopping Reminders",
  "policy.shopping.desc": "Reminds at the selected time if there are unpurchased items in the shopping list.",
  "policy.shopping.pending": "If there are pending items",
  "policy.task.title": "Task Reminders",
  "policy.task.desc": "Sends tasks with approaching or overdue due dates according to the time policy.",
  "policy.rule.3days": "3 days before",
  "policy.rule.1day": "1 day before",
  "policy.rule.today": "Due today",
  "policy.task.overdue": "Overdue task",
  "policy.calendar.title": "Calendar Reminders",
  "policy.calendar.desc": "Reminds family events on event day, 1 day before, or as a weekly summary.",
  "policy.calendar.today": "Event day",
  "policy.calendar.week": "This week summary",
  "policy.document.title": "Document Due Date",
  "policy.document.desc": "Manages how many days before document validity dates notifications are sent.",
  "policy.rule.30days": "30 days before",
  "policy.rule.10days": "10 days before",
  "policy.rule.5days": "5 days before",
  "policy.document.today": "Expires today",
  "policy.document.expired": "Expired",
  "policy.health.title": "Health and Medicine",
  "policy.health.desc": "Manages health appointment and medicine dose reminders.",
  "policy.health.appt1day": "Appointment 1 day before",
  "policy.health.apptToday": "Appointment day",
  "policy.health.meds": "Medicines at their own time",

  "common.saving": "Saving...",
  "common.actionFailed": "Couldn’t save · Try again",
  "common.processing": "Processing…",
  "common.validation.title": "Complete the required fields",
  "common.validation.fillFields": "Fields to complete:",
  "common.updating": "Updating...",
  "profile.newPasswordRepeat": "Repeat new password",
  "profile.currentPasswordWrong": "Current password is incorrect.",
  "profile.passwordUpdateFailed": "Password could not be updated.",
  "family.tapMemberDetails": "Tap a member to view details.",
  "family.shareCodeInvite": "You can share this code to add a new member.",
  "family.leaveGroup": "Leave family group",
  "shopping.product": "Product",
  "shopping.bought": "Bought",
  "common.noneYet": "None yet",
  "finance.topExpense": "Top Expense",
  "finance.visibleAfterExpense": "Appears after an expense is added",
  "finance.familyExpenses": "Family Expenses",
  "finance.thisMonthSharedTotal": "Total shared expenses this month",
  "finance.health": "Financial Health",
  "finance.underControl": "Under control",
  "finance.needsAttention": "Needs attention",
  "finance.incomeRatio": "Income ratio",
  "finance.expenseRatio": "Expense ratio",
  "notify.shoppingListTitle": "🛒 Shopping List",
  "notify.shoppingAdded": "{{name}} added \"{{item}}\" to the list",
  "notify.shoppingBulkTitle": "🛒 List Updated",
  "notify.shoppingBulkAdded": "{{name}} updated the shopping list: {{count}} new items were added.",
  "notify.receiptBulkTitle": "🧾 Receipt Added",
  "notify.receiptBulkAdded": "{{name}} scanned a receipt: {{count}} expense items were added.",
  "notify.shoppingBoughtTitle": "🛒 Product Bought",
  "notify.shoppingBought": "{{name}} marked \"{{item}}\" as bought",

  /* ── Automation / reminder SUMMARY texts (for in-app rendering) ── */
  "auto.shoppingReminder.single": "Don't forget to buy {{item}}.",
  "auto.shoppingReminder.multi": "You have {{count}} pending items in your shopping list.",
  "auto.taskReminder.singleOverdue": "The task {{task}} is overdue.",
  "auto.taskReminder.singleUpcoming": "Don't forget the task {{task}}.",
  "auto.taskReminder.multiOverdue": "You have {{count}} overdue tasks.",
  "auto.taskReminder.multiUpcoming": "You have {{count}} upcoming tasks.",
  "auto.taskReminder.multiMixed": "You have {{overdue}} overdue and {{upcoming}} upcoming tasks.",
  "auto.calendarReminder.single": "Don't forget the event {{event}}.",
  "auto.calendarReminder.multiWeekly": "You have {{count}} events on your calendar this week.",
  "auto.calendarReminder.multi": "You have {{count}} upcoming events on your calendar.",
  "auto.documentExpiry.single": "Check the validity date of {{document}}.",
  "auto.documentExpiry.expired": "{{count}} of your documents have expired.",
  "auto.documentExpiry.expiring": "{{count}} of your documents are about to expire.",
  "documentExpiry.reminderTitle": "📁 Document Reminder",
  "auto.healthReminder.single": "Check your appointment for {{record}}.",
  "auto.healthReminder.multi": "You have {{count}} health appointments.",
  "auto.healthReminder.medicineSingle": "Check your medicine/health record for {{record}}.",
  "auto.healthReminder.medicineMulti": "You have {{count}} health/medicine reminders for {{time}}.",
  "health.reminderTitle": "❤️ Health Reminder",
  "auto.financeReminder.single": "Check the due date for {{record}}.",
  "auto.financeReminder.multi": "You have {{count}} upcoming finance payments.",
  "finance.reminderTitle": "💰 Finance Reminder",
  "auto.generic.single": "You have a reminder for {{record}}.",
  "auto.generic.multi": "You have {{count}} reminders.",

  /* ── Map / location notifications (for in-app rendering) ── */
  "auto.push.nearby.bodyVeryClose": "{{member}} is very close to you!",
  "auto.push.location.timedBodyMinutes": "{{member}} is sharing their location for {{value}} minutes",
  "auto.push.location.timedBodyHours": "{{member}} is sharing their location for {{value}} hours",
  "auto.push.geofence.addedBothBody": "An entry/exit notification was added for \"{{zone}}\"",

  "common.someone": "Someone",
  "notify.taskAssignedTitle": "✅ New Task Assigned",
  "notify.taskAssigned": "\"{{task}}\" has been assigned to you",
  "notify.taskCompletedTitle": "✅ Task Completed",
  "notify.taskCompleted": "{{name}} completed \"{{task}}\"",
  "notify.newIncome": "💰 New Income",
  "notify.newExpense": "💰 New Expense",
  "notify.documentUploadedTitle": "📁 New Document Uploaded",
  "notify.documentUploaded": "{{name}}: {{title}}",
  "notify.expenseReminder.item": "Don’t forget the \"{{item}}\" expense!",
  "notify.expenseReminder.default": "You have an expense reminder.",
  "notify.sharedExpenseTitle": "💸 Shared Expense",
  "notify.sharedExpenseAdded": "{{name}} added a shared expense: {{title}} ({{amount}})",
  "notify.financeAdded": "{{name}} added \"{{title}}\" ({{amount}})",
  "notify.healthEventTitle": "❤️ Health Record",
  "notify.healthEventAdded": "{{name}} added a health record: {{title}}",
  "notify.childRecordTitle": "👶 Child Record",
  "notify.childRecordAdded": "{{name}} added a child record: {{title}}",
  "notify.chatTitle": "Chat",
  "notify.chatTitleIcon": "💬 Chat",
  "notify.calendarEventTitle": "📅 New Event",
  "notify.calendarEventAdded": "{{name}} added an event: {{event}}",
  "family.member": "Family member",
  "calendar.healthAppointment": "Health Appointment",
  "notification.oneDayBefore": "1 day before",
  "calendar.premium.recurringEvents": "Recurring events",
  "calendar.premium.familySync": "Family calendar sync",
  "premium.unlimitedAllModules": "Unlimited use in all modules",

  /* ── Notification popup i18n completion ── */
  "notification.title": "Notifications",
  "notification.empty": "No notifications yet",
  "notification.markRead": "Mark as read",
  "notification.markUnread": "Mark as unread",
  "notification.markAllRead": "Mark all as read",
  "notification.markAllReadShort": "Mark all read",
  "notification.deleteAll": "Delete all",
  "notification.clearAll": "Clear all",
  "notification.deleteRead": "Delete read notifications",
  "notification.close": "Close",
  "notification.stats": "Statistics",
  "notification.tab.general": "General",
  "notification.tab.chat": "Chat",
  "notification.searchPlaceholder": "Search notifications…",
  "notification.unread": "Unread",
  "notification.read": "Read",
  "notification.readRate": "Read",
  "notification.star.add": "Star",
  "notification.star.remove": "Remove star",
  "notification.empty.search": "No results found",
  "notification.empty.starred": "No starred notifications",
  "notification.empty.unread": "All notifications are read",
  "notification.empty.searchFor": "No match for \"{{query}}\"",
  "notification.action.shopping": "Go to list",
  "notification.action.task": "Go to task",
  "notification.action.calendar": "Go to calendar",
  "notification.action.finance": "Go to finance",
  "notification.action.sharedExpense": "Go to expense",
  "notification.action.health": "Go to health",
  "notification.action.chat": "Go to chat",
  "notification.action.document": "Go to document",
  "notification.action.open": "Open notification",
  "notification.action.announcement": "Open announcement",
  "notification.ago.now": "Just now",
  "notification.ago.minutes": "min ago",
  "notification.ago.hours": "hr ago",
  "notification.ago.days": "days ago",

  "notify.installmentReminder.title": "🧾 Installment Payment Reminder",
  "notify.installmentReminder.body": "The installment payment for \"{{name}}\" is coming up!",
  "finance.installment.tomorrowTitle": "🧾 An installment is due tomorrow",
  "finance.installment.tomorrowBody": "Your {{amount}} payment for \"{{name}}\" is due tomorrow. A friendly heads-up so you can be ready 😊",
  "finance.installment.todayTitle": "🧾 Today's installment reminder",
  "finance.installment.todayBody": "Your installment for \"{{name}}\" is due today. Take care of it and enjoy the peace of mind 😊",
  "finance.subscription.tomorrowTitle": "🔄 A subscription renews tomorrow",
  "finance.subscription.tomorrowBody": "\"{{name}}\" renews tomorrow for {{amount}}. Just a friendly reminder to leave a little room in your budget 😊",
  "finance.subscription.todayTitle": "🔄 Subscription renewal day",
  "finance.subscription.todayBody": "\"{{name}}\" renews today for {{amount}}. Just keeping you in the loop 😊",
  "finance.bill.tomorrowTitle": "📋 A bill is due tomorrow",
  "finance.bill.tomorrowBody": "Your {{amount}} bill for \"{{name}}\" is due tomorrow. A quick heads-up so it doesn't get left until the last minute 😊",
  "finance.bill.todayTitle": "📋 Bill payment day",
  "finance.bill.todayBody": "Your {{amount}} bill for \"{{name}}\" is due today. Just making sure it doesn't slip your mind 😊",
  "notify.subscriptionReminder.title": "🔄 Subscription Renewal Reminder",
  "notify.subscriptionReminder.body": "Your \"{{name}}\" subscription will renew soon!",
  "notify.billReminder.title": "📋 Bill Payment Reminder",
  "notify.billReminder.body": "The due date for \"{{name}}\" bill is coming up!",


  "finance.savings.reminderBody": "Don't forget to update your \"{{name}}\" saving!",
  "auto.push.location.shareOnTitle": "📍 Location Sharing Enabled",
  "auto.push.location.shareOnBody": "{{member}} started sharing their location",
  "auto.push.location.timedTitle": "⏱ Timed Location Sharing",
  "auto.push.location.timedBody": "{{member}} is sharing their location for {{duration}}",
  "auto.push.sos.title": "🆘 EMERGENCY HELP!",
  "auto.push.sos.body": "{{member}} is asking for help! Their location was shared.",
  "auto.push.meeting.title": "🤝 Meeting Point Set",
  "auto.push.meeting.body": "{{member}} set \"{{place}}\" as the meeting point",
  "auto.push.geofence.newTitle": "🔔 New Geofence",
  "auto.push.geofence.addedBody": "A {{mode}} notification was added for \"{{zone}}\"",
  "auto.push.geofence.addedEntryBody": "An entry notification was added for \"{{zone}}\"",
  "auto.push.geofence.addedExitBody": "An exit notification was added for \"{{zone}}\"",
  "auto.push.safeZone.newTitle": "🟢 New Safe Zone",
  "auto.push.safeZone.addedBody": "\"{{zone}}\" was defined as a safe zone",
  "auto.push.nearby.title": "📡 Family Member Nearby",
  "auto.push.nearby.body": "{{member}} is {{distance}} from you",

  /* ── Notification i18n final fixes ── */
  "auto.push.zone.safeTitle": "{{emoji}} Safe Zone: {{zone}}",
  "auto.push.zone.geofenceTitle": "{{emoji}} Geofence: {{zone}}",
  "auto.push.zone.enterBody": "{{member}} entered the \"{{zone}}\" area{{distance}}",
  "auto.push.zone.exitBody": "{{member}} left the \"{{zone}}\" area{{distance}}",
  "notify.shoppingReminder.item": "Don't forget to buy \"{{item}}\"!",
  "notify.shoppingReminder.default": "Check your shopping list.",
  "notify.taskReminder.item": "Don't forget the task \"{{task}}\"!",
  "notify.taskReminder.default": "Check your task.",
  "notify.calendarReminder.body": "Don't forget the event {{event}}{{timeText}}!",

  "nav.activity": "Family Activity Feed",
  "home.activitySub": "Latest family actions",
  "activity.title": "Family Activity Feed",
  "activity.subtitle": "Follow important family activities and updates in a single timeline.",
  "activity.heroBadge": "LIVE FAMILY HUB",
  "activity.stat.today": "Today",
  "activity.stat.week": "This week",
  "activity.stat.mostActive": "Most active",
  "activity.stat.unread": "New",
  "activity.search": "Search activity...",
  "activity.new": "New",
  "activity.someone": "A family member",
  "activity.emptyTitle": "No activity yet",
  "activity.emptyText": "As your family uses the app, a live timeline will appear here.",
  "activity.group.today": "Today",
  "activity.group.yesterday": "Yesterday",
  "activity.group.week": "This Week",
  "activity.group.older": "Older",
  "activity.category.all": "All",
  "activity.category.shopping": "Shopping",
  "activity.category.tasks": "Tasks",
  "activity.category.calendar": "Calendar",
  "activity.category.finance": "Finance",
  "activity.category.documents": "Documents",
  "activity.category.health": "Health",
  "activity.category.children": "Children",
  "activity.category.chat": "Chat",
  "activity.category.management": "Management",
  "activity.title.shoppingAdded": "Item added",
  "activity.title.shoppingCompleted": "Item bought",
  "activity.title.shoppingDeleted": "Item deleted",
  "activity.title.taskAdded": "Task added",
  "activity.title.taskCompleted": "Task completed",
  "activity.title.taskDeleted": "Task deleted",
  "activity.title.calendarAdded": "Event added",
  "activity.title.calendarUpdated": "Event updated",
  "activity.title.calendarDeleted": "Event deleted",
  "activity.title.incomeAdded": "Income added",
  "activity.title.financeAdded": "Finance record added",
  "activity.title.expenseAdded": "Expense added",
  "activity.title.financeDeleted": "Finance record deleted",
  "activity.title.documentAdded": "Document added",
  "activity.title.documentDeleted": "Document deleted",
  "activity.title.healthAdded": "Health record added",
  "activity.title.childAdded": "Child tracking record added",
  "activity.title.managementNotification": "Family notification sent",
  "activity.msg.shoppingAdded": "{{actor}} added “{{item}}” to the shopping list.",
  "activity.msg.shoppingCompleted": "{{actor}} marked “{{item}}” as bought.",
  "activity.msg.shoppingDeleted": "{{actor}} deleted “{{item}}” from the list.",
  "activity.msg.taskAdded": "{{actor}} created the task “{{item}}”.",
  "activity.msg.taskCompleted": "{{actor}} completed the task “{{item}}”.",
  "activity.msg.taskDeleted": "{{actor}} deleted the task “{{item}}”.",
  "activity.msg.calendarAdded": "{{actor}} added “{{item}}” to the calendar.",
  "activity.msg.calendarUpdated": "{{actor}} updated the event “{{item}}”.",
  "activity.msg.calendarDeleted": "{{actor}} deleted the event “{{item}}”.",
  "activity.msg.financeAdded": "{{actor}} added the finance record “{{item}}”{{amount}}.",
  "activity.msg.financeDeleted": "{{actor}} deleted the finance record “{{item}}”.",
  "activity.msg.documentAdded": "{{actor}} added the document “{{item}}”.",
  "activity.msg.documentDeleted": "{{actor}} deleted the document “{{item}}”.",
  "activity.msg.healthAdded": "{{actor}} added the health record “{{item}}”.",
  "activity.msg.childAdded": "{{actor}} added the child tracking record “{{item}}”.",
  "activity.msg.managementNotification": "{{actor}} sent the family notification “{{item}}”.",
  "activity.showMore": "Show {{count}} more",

  "profile.tab.avatar": "Avatar",
  "profile.avatar.title": "Choose Your Avatar",
  "profile.avatar.hint": "Suggested for you",
  "profile.avatar.initials": "Initials color avatar",
  "profile.avatar.colors": "Choose Your Color",
  "profile.avatar.all": "All avatars",
  "profile.avatar.save": "Save Avatar",
  "profile.avatar.savedOk": "Avatar updated ✓",
  "profile.avatar.saveFail": "Failed to update avatar.",
  "profile.photo.title": "Use your own photo",
  "profile.photo.subtitle": "Take a photo or choose one from your library, then position your face inside the circle.",
  "profile.photo.camera": "Take photo",
  "profile.photo.gallery": "Choose from library",
  "profile.photo.privacy": "Your photo is used only for your profile appearance.",
  "profile.photo.editorTitle": "Adjust your photo",
  "profile.photo.editorSubtitle": "The area inside the circle will become your avatar",
  "profile.photo.editorHint": "Drag the photo, then pinch or use the slider to zoom.",
  "profile.photo.zoom": "Photo zoom",
  "profile.photo.rotate": "Rotate",
  "profile.photo.reset": "Reset",
  "profile.photo.use": "Use Photo",
  "profile.photo.uploading": "Uploading… {{percent}}%",
  "profile.photo.preparing": "Preparing photo…",
  "profile.photo.saved": "Your profile photo was updated ✓",
  "profile.photo.remove": "Remove photo",
  "profile.photo.removeTitle": "Remove profile photo?",
  "profile.photo.removeConfirm": "Your uploaded profile photo will be permanently deleted. This action cannot be undone.",
  "profile.photo.unsupported": "This photo could not be opened. Choose a JPG, PNG, WebP, or HEIC photo.",
  "profile.photo.tooLarge": "The selected photo is too large. Choose a photo up to 25 MB.",
  "profile.photo.uploadFailed": "Your profile photo could not be uploaded. Check your connection and try again.",
  "profile.photo.editorError": "The photo could not be prepared. Try again with a different photo.",

  "children.avatar.title": "Choose Avatar",
  "children.avatar.change": "Change Avatar",
  "children.avatar.save": "Save",
  "children.avatar.savedOk": "Avatar updated ✓",
  "children.avatar.saveFail": "Failed to update avatar.",
  "children.photo.use": "Use uploaded photo",
  "children.photo.removeTitle": "Remove profile photo?",
  "children.photo.removeConfirm": "The photo uploaded for this child, baby, or pet profile will be permanently deleted. This action cannot be undone.",
  "children.photo.uploadFailed": "The profile photo could not be uploaded. Check your connection and try again.",
  "children.photo.deleteFailed": "The profile photo could not be removed. Please try again.",

  /* ── Daily login reminder popup ── */
  "daily.popup.title": "📋 Today & Upcoming",
  "daily.popup.close": "Close",
  "daily.popup.noItems": "No reminders for today 🎉",
  "daily.popup.task": "Task",
  "daily.popup.event": "Event",
  "daily.popup.medicine": "Medicine",
  "daily.popup.appointment": "Appointment",
  "daily.popup.birthday": "🎂 Birthday",
  "daily.popup.overdue": "Overdue",
  "daily.popup.today": "Today",
  "daily.popup.tomorrow": "Tomorrow",
  "daily.popup.daysLeft": "{{days}} days left",

  /* ── Birthday notifications ── */
  "notify.birthday.title": "🎂 It's {{name}}'s Birthday Today!",
  "notify.birthday.body": "Don't forget to wish {{name}} a happy birthday from the whole family! 🎉💕",

  /* ── Chat: sender-named push notification ── */
  "notify.chatMessage": "{{senderName}}: {{message}}",

  /* ── In-app dialog / toast ── */
  "mgmt.sched.confirmCancelRecurring": "Do you want to cancel this recurring system announcement?",
  "dialog.confirmTitle": "Confirm",
  "dialog.infoTitle": "Info",
  "dialog.confirm": "Confirm",
  "dialog.cancel": "Cancel",
  "dialog.ok": "OK",
  "dialog.close": "Close",

  "mgmt.field.message": "Message",
  "mgmt.field.dateTime": "Date / Time",
  "mgmt.field.repeatType": "Repeat Type",
  "mgmt.field.plannedDateTime": "Scheduled Date / Time",
  "mgmt.notif.last50": "🕘 Last 50 Notifications",
  "mgmt.notif.last100": "Last 100 Notifications",
  "mgmt.notif.tabAnnouncements": "📢 Announcements",
  "mgmt.notif.tabAutomation": "⚙️ Automatic Notification Checks",
  "mgmt.notif.noAutomationHistory": "No automated notification records yet.",
  "mgmt.notif.errorLabel": "Error",
  "mgmt.notif.plannedLabel": "Scheduled",
  "mgmt.notif.repeatLabelShort": "Repeat",
  "mgmt.auto.resume": "▶️ Resume",
  "mgmt.auto.pause": "⏸️ Pause",
  "mgmt.noRepeatingAnnouncement": "No recurring system announcement.",


  /* ── Children tracking premium header ── */
  "children.tracking.archive": "Family Archive",
  "children.tracking.title": "Child / Baby / Pet Tracking",
  "children.tracking.subtitle": "Track growth, health, education, routines and pet care records in a calm family archive.",
  "children.tracking.addProfile": "Add",
  "children.type.child": "Child",
  "children.type.baby": "Baby",
  "children.type.pet": "Pet",
  "auth.resetPasswordTitle": "Renew your password",
  "auth.resetPasswordSubtitle": "Create a secure new password for your Aile Yönetimi account.",
  "auth.resetLinkChecking": "Checking the link",
  "auth.resetLinkCheckingSub": "Your password reset link is being verified securely.",
  "auth.resetLinkInvalidTitle": "Invalid link",
  "auth.resetLinkInvalid": "This password reset link is invalid, already used, or expired.",
  "auth.createNewPassword": "Create new password",
  "auth.createNewPasswordSub": "For your security, choose a new password between 8 and 128 characters.",
  "auth.placeholder.newPassword": "New password",
  "auth.placeholder.confirmNewPassword": "Confirm new password",
  "auth.saveNewPassword": "Save new password",
  "auth.resetPasswordMin": "New password must be between 8 and 128 characters.",
  "auth.resetPasswordMismatch": "New passwords do not match.",
  "auth.resetPasswordFailed": "Password could not be updated. Please try again.",
  "auth.resetPasswordSuccessTitle": "Password updated",
  "auth.resetPasswordSuccessSub": "You can now sign in with your new password.",
  /* ── Aile Asistanı ── */
  "nav.assistant": "Family Assistant",
  "assistant.title": "Family Assistant",
  "assistant.subtitle": "Preparing your smart daily family summary.",
  "assistant.todaySummary": "Today's smart summary",
  "assistant.priority": "Priority items",
  "assistant.smartAdvice": "Family Assistant Suggestions",
  "assistant.finance": "Finance",
  "assistant.tasks": "Tasks",
  "assistant.calendar": "Calendar",
  "assistant.shopping": "Shopping",
  "assistant.health": "Health",
  "assistant.documents": "Documents",
  "assistant.children": "Children",
  "assistant.map": "Map",
  "assistant.chat": "Chat",
  "assistant.notifications": "Notifications",
  "assistant.empty.title": "No critical item yet",
  "assistant.empty.desc": "Your family plan looks calm today. Add your first task, shopping item or calendar record to enrich Assistant insights.",
  "assistant.disclaimer.health": "These suggestions are informational and do not replace medical advice.",
  "assistant.viewDetails": "View details",
  "assistant.refresh": "Refresh",
  "assistant.updatedNow": "Updated",
  "assistant.loading": "Preparing summary",
  "assistant.scoreExplain": "How is the score calculated?",
  "assistant.score": "status score",
  "assistant.error": "Summary could not be loaded. Please try again.",
  "scan.previewTitle": "Scanned Items",
  "scan.previewTitleReceipt": "Scanned Receipt",

  /* ── My Private Cycle ── */
  "cycle.title": "My Private Cycle",
  "cycle.private": "Only you can see this",
  "cycle.day": "day",
  "cycle.days": "days",
  "cycle.today": "Today",
  "cycle.late": "Late",
  "cycle.daysLate": "days late",

  "cycle.onb.welcome": "Welcome to My Private Cycle",
  "cycle.onb.welcomeDesc": "Track your menstrual cycle, symptoms, and health data privately and securely.",
  "cycle.onb.lastPeriod": "Last period start date",
  "cycle.onb.cycleLength": "Cycle Length",
  "cycle.onb.cycleLengthDesc": "What is your average cycle length and period duration?",
  "cycle.onb.avgCycle": "Average cycle:",
  "cycle.onb.avgPeriod": "Average period:",
  "cycle.onb.privacy": "Privacy Guarantee",
  "cycle.onb.privacyDesc": "This data is completely private. No family member, admin, or system administrator can see it.",
  "cycle.onb.start": "Start Tracking",

  "cycle.hero.today": "Today",
  "cycle.hero.nextPeriod": "Next period",
  "cycle.hero.ovulation": "Ovulation",
  "cycle.hero.fertile": "Fertile window",
  "cycle.hero.regularity": "Regularity",
  "cycle.hero.activePeriod": "Your period is ongoing",
  "cycle.confidence.starter": "Starter estimate",
  "cycle.confidence.medium": "Improving estimate",
  "cycle.confidence.high": "Strong estimate",

  "cycle.qa.start": "Period Started",
  "cycle.qa.end": "Period Ended",
  "cycle.qa.symptom": "Add Symptom",
  "cycle.qa.note": "Add Note",

  "cycle.period.date": "Date",
  "cycle.period.flow": "Flow intensity",

  "cycle.tab.home": "Home",
  "cycle.tab.calendar": "Calendar",
  "cycle.tab.analysis": "Analysis",
  "cycle.tab.meds": "Medications",

  "cycle.mood.title": "Mood",
  "cycle.pain.title": "Pain Level",
  "cycle.symptoms.title": "Symptoms",
  "cycle.discharge.title": "Discharge",
  "cycle.note.title": "Notes",
  "cycle.note.placeholder": "Your note for today...",

  "cycle.legend.period": "Period",
  "cycle.legend.predicted": "Predicted",
  "cycle.legend.ovulation": "Ovulation",
  "cycle.legend.fertile": "Fertile",
  "cycle.legend.pms": "PMS",

  "cycle.insights.title": "Smart Insights",

  "cycle.meds.title": "Medication Tracker",
  "cycle.meds.add": "Add Medication",
  "cycle.meds.namePlaceholder": "Medication name",
  "cycle.meds.dosagePlaceholder": "Dosage (e.g. 500mg)",
  "cycle.meds.empty": "No medications added yet.",
  "cycle.prediction.title": "Cycle predictions",
  "cycle.meds.emptyTitle": "Medication tracking is ready",
  "cycle.meds.emptyDesc": "Create private reminders for pain relief, vitamins, or medication you use regularly.",
  "cycle.meds.emptyFeature1": "Choose a time and get gentle reminders.",
  "cycle.meds.emptyFeature2": "These records stay private to you.",
  "cycle.meds.emptyFeature3": "Dosage, notes, and editing support.",
  "cycle.meds.addFirst": "Add first medication",

  "cycle.analysis.title": "Analysis",
  "cycle.analysis.periodCount": "Period count",
  "cycle.analysis.avgCycle": "Avg. cycle",
  "cycle.analysis.avgPeriod": "Avg. period",
  "cycle.analysis.regularity": "Regularity",
  "cycle.analysis.cycleTrend": "Cycle length trend",
  "cycle.analysis.painTrend": "Pain trend",
  "cycle.analysis.moodDist": "Mood distribution",
  "cycle.analysis.topSymptoms": "Top symptoms",

  "cycle.settings.title": "Settings",
  "cycle.settings.notifications": "Notifications",
  "cycle.settings.notificationTimes": "Notification Times",
  "cycle.settings.notificationTimesHint": "Choose when daily log, period reminders and cycle alerts should be sent.",
  "cycle.settings.defaultTime": "Default: {time}",
  "cycle.settings.privacy": "Privacy & Features",
  "cycle.settings.export": "Export Data",
  "cycle.settings.deleteData": "Delete Data",
  "cycle.settings.deleteAll": "Delete all data",
  "cycle.settings.deleteConfirm": "All your cycle data will be permanently deleted. This action cannot be undone.",
  "cycle.settings.sexualTracking": "Sexual health tracking (optional)",
  "cycle.settings.pregnancyMode": "Pregnancy planning mode",

  "cycle.notif.period7d": "Period 7 days ahead",
  "cycle.notif.period3d": "Period 3 days ahead",
  "cycle.notif.period1d": "Period 1 day ahead",
  "cycle.notif.periodToday": "Estimated period day",
  "cycle.notif.ovulation": "Ovulation phase",
  "cycle.notif.fertile": "Fertile window",
  "cycle.notif.pms": "PMS start",
  "cycle.notif.dailyLog": "Daily log reminder",
  "cycle.notif.delay": "Delay alert",
  "cycle.notif.medication": "Medication reminder",
  "cycle.notif.privateMode": "Private notification mode",

  "cycle.privacy.familyHide": "Family members cannot see this",
  "cycle.privacy.adminHide": "Admins cannot see this",
  "cycle.privacy.superAdminHide": "Super admin cannot see this",
  "cycle.privacy.onlyYou": "Only you can access this data",

  "common.next": "Next",
  "common.confirm": "Confirm",
  /* ── Özel Takvimim — ek anahtarlar ── */
  "cycle.ai.title": "Recommendations",
  "cycle.calendar.hasEntry": "This day has a saved entry",
  "cycle.analysis.periodTrend": "Period duration trend",
  "cycle.ai.empty": "Personal insights will appear here as you log more data.",
  "cycle.ai.tip1": "Log your period start to activate predictions.",
  "cycle.ai.tip2": "Daily symptom tracking helps identify patterns.",
  "cycle.ai.tip3": "After 3 cycles, personalized insights appear here.",
  "cycle.ai.tip4": "Water intake, sleep, and light movement notes help interpret your cycle more accurately.",
  "cycle.ai.tip5": "Ovulation and fertile-window predictions become more accurate as your history grows.",
  "cycle.ai.tip6": "Short daily notes about pain or mood changes improve your monthly analysis.",
  "cycle.ai.tip7": "If bleeding is very heavy, pain is severe, or symptoms feel unusual, consider contacting a clinician.",
  "cycle.calInfo.thisCycle": "This cycle",
  "cycle.calInfo.hint": "Tap any day to add symptoms, mood or notes.",
  "cycle.analysis.empty.title": "Start Tracking Your Cycle",
  "cycle.analysis.empty.desc": "Charts and trends will appear as you log more data.",
  "cycle.analysis.empty.s1": "Log period start",
  "cycle.analysis.empty.s2": "Track daily symptoms",
  "cycle.analysis.empty.s3": "Charts activate after 3 cycles",
  "cycle.meds.editTitle": "Edit Medication",
  "cycle.meds.update": "Update",
  "cycle.pregnancy.banner": "Pregnancy Planning Mode Active",
  "cycle.pregnancy.tip": "Track your fertile window for the best chances.",
  "cycle.pregnancy.bestDays": "Best days",
  "cycle.sexual.title": "Sexual Health",
  "cycle.sexual.protected": "Protected",
  "cycle.sexual.unprotected": "Unprotected",
  "cycle.sexual.pregnancyIntent": "Planning pregnancy",
  "cycle.hero.cycleDay": "Cycle Day",
  "cycle.hero.period": "Period",
  "cycle.period.addPast": "Add Past Period",
  "cycle.period.startDate": "Start date",
  "cycle.period.endDate": "End date (optional)",
  "cycle.period.startHelp": "Log your dates and flow so your estimates can become more personal over time.",
  "cycle.period.endHelp": "Choose the day your period ended. Your cycle will update from this date.",
  "cycle.period.ongoing": "Ongoing",
  "cycle.period.completed": "Completed",
  "cycle.period.ongoingHint": "You can close this record with one tap when your period ends.",
  "cycle.tab.swipeHint": "Swipe to switch tabs",
  "cycle.analysis.insights": "Cycle Insights",
  "cycle.analysis.noTrend": "No trend data yet",


  /* ── Finance notifications (missing from EN) ── */
  "auto.finance.title": "Finance Reminders",
  "auto.finance.desc": "Automatically reminds you of installment, subscription and bill due dates.",
  "mgmt.auto.finance.bills": "Bills",
  "mgmt.auto.finance.installments": "Installments",
  "mgmt.auto.finance.subscriptions": "Subscriptions",
  "policy.finance.title": "Finance Notifications",
  "policy.finance.desc": "Due date reminders for finance cards.",
  "policy.finance.3days": "3 days before",
  "policy.finance.today": "On due date",
  "policy.finance.installmentBefore": "Installment - before payment",
  "policy.finance.installmentToday": "Installment - payment day",
  "policy.finance.subscriptionBefore": "Subscription - before renewal",
  "policy.finance.subscriptionToday": "Subscription - renewal day",
  "policy.finance.billBefore": "Bill - before payment",
  "policy.finance.billToday": "Bill - payment day",
  "policy.finance.savingValue": "Savings - value check",
  "policy.finance.savingContribution": "Savings - contribution reminder",
  "cycle.analysis.healthScore": "Health insight",
  "cycle.analysis.scoreGood": "Your cycle looks regular. Predictions get clearer as you keep logging.",
  "cycle.analysis.scoreMedium": "Your tracking pattern is forming. A few more logs will improve prediction quality.",
  "cycle.analysis.scoreLow": "Your cycle looks variable. Regular logs improve delay and symptom tracking.",
  "cycle.analysis.scoreStart": "Analysis is being prepared with your first data. It will get richer as you log more.",
  "cycle.analysis.nextWindow": "Next window",
  "cycle.analysis.ovulationWindow": "Ovulation view",
  "cycle.analysis.notEnough": "Will become clearer with more logs",

  // ── Map / Zone notifications (auto.push) ──────────────────────
  "auto.push.zone.placeTitle":       "📍 Shared Place — {{zone}}",
  "auto.push.zone.created.safe":     "🟢 '{{zone}}' safe zone created! You'll now get notifications for arrivals and departures 🏠",
  "auto.push.zone.created.geo":      "🔔 '{{zone}}' geofence created! You'll be notified whenever someone enters or leaves 📍",
  "auto.push.zone.created.place":    "📍 Notifications added for '{{zone}}'! You'll know when family members arrive or leave 🗺️",
  "auto.push.safe.enter":            "{{member}} arrived at '{{zone}}' safe zone! Everything's fine, all is calm ✨",
  "auto.push.safe.exit":             "{{member}} left the '{{zone}}' safe zone. Safe travels, take good care! 👋",
  "auto.push.geo.enter":             "{{member}} arrived at '{{zone}}'. Don't worry, we're keeping an eye out 📍",
  "auto.push.geo.exit":              "{{member}} left '{{zone}}'. Journey continues, safe travels! 🛤️",
  "auto.push.place.enter":           "{{member}} arrived near '{{zone}}'! Looks like someone's stopping by 😊",
  "auto.push.place.exit":            "{{member}} left '{{zone}}'. See you next time! 👋",
  "auto.push.child.okul.enter":      "🏫 {{member}} arrived at school safely! Have a great day 📚",
  "auto.push.child.okul.exit":       "📌 {{member}} left school. Hope they had a great day! 🌟",
  "auto.push.child.kres.enter":      "🧸 {{member}} arrived at daycare safely! Have a wonderful day 💛",
  "auto.push.child.kres.exit":       "🏠 {{member}} left daycare, heading home! See you soon sweetheart 💕",
  "auto.push.child.yuzme.enter":     "🏊 {{member}} arrived at swimming! Let's dive in 🌊",
  "auto.push.child.yuzme.exit":      "🚿 {{member}} left swimming. Great workout! 💪",
  "auto.push.child.spor.enter":      "⚽ {{member}} arrived at sports! Go for it 💪",
  "auto.push.child.spor.exit":       "🏆 {{member}} left sports. Amazing session! 🌟",
  "auto.push.child.dershane.enter":  "📚 {{member}} arrived at tutoring, ready to learn ✏️",
  "auto.push.child.dershane.exit":   "📖 {{member}} left tutoring. Hard work pays off! 🌟",
  "auto.push.child.kurs.enter":      "🎨 {{member}} arrived at class! Time to be creative 🖌️",
  "auto.push.child.kurs.exit":       "🎭 {{member}} left class. Had a wonderful time! ✨",
  "auto.push.child.park.enter":      "🌳 {{member}} arrived at the park! Fun time ahead 🎪",
  "auto.push.child.park.exit":       "🏠 {{member}} left the park, heading home! Fresh air was great 🌸",
  "auto.push.child.diger.enter":     "🌟 {{member}} arrived safely at \"{{zone}}\"!",
  "auto.push.child.diger.exit":      "👣 {{member}} left \"{{zone}}\".",

  /* ── Offline banner ── */
  "offline.banner": "No internet connection — showing last saved data",

  /* ── Yasal Belgeler / Legal Documents ── */
  "settings.privacy.legalDocuments": "Legal Documents",
  "settings.privacy.legalDocumentsHint": "Review privacy, service, and account deletion documents.",
  "settings.privacy.privacyPolicy": "Privacy Policy",
  "settings.privacy.privacyPolicyHint": "See how your data is processed and protected.",
  "settings.privacy.termsOfService": "Terms of Service",
  "settings.privacy.termsOfServiceHint": "Rules and responsibilities for using the service.",
  "settings.privacy.accountDeletionInfo": "Account Deletion Information",
  "settings.privacy.accountDeletionInfoHint": "Account deletion, data export, and retention periods.",


  "auth.register.personalInfo": "Personal Information",
  "auth.register.required": "Required fields",
  "auth.register.name": "First Name",
  "auth.register.surname": "Last Name",
  "auth.register.birthDate": "Date of Birth",
  "auth.register.birthDateHelp": "Used for age calculations and birthday reminders.",
  "auth.register.gender": "Gender",
  "auth.register.familyProfile": "Family Profile",
  "auth.register.phone": "Phone",
  "auth.register.username": "Username",
  "auth.register.role": "Family Role",
  "auth.register.accountInfo": "Account Information",
  "auth.register.email": "Email",
  "auth.register.password": "Password",
  "auth.error.nameRequired": "Enter your first name.",
  "auth.error.nameMin": "First name must be at least 3 characters.",
  "auth.error.surnameRequired": "Enter your last name.",
  "auth.error.surnameMin": "Last name must be at least 2 characters.",
  "auth.error.birthDateRequired": "Select your date of birth.",
  "auth.error.usernameRequired": "Enter a username.",
  "auth.error.emailInvalid": "Enter a valid email address.",
  "auth.register.healthInfo": "Health information",
  "auth.register.optional": "Optional",
  "auth.register.bloodGroup": "Blood Group",
  "auth.register.height": "Height",
  "auth.register.weight": "Weight",
  "auth.social.google": "Continue with Google",
  "auth.social.apple": "Continue with Apple",
  "auth.social.orEmail": "or with email and password",
  "auth.social.quickRegister": "Fast and secure registration",
  "auth.social.orForm": "or complete the form",
  "auth.social.completeProfile": "Complete Your Profile",
  "auth.social.completeProfileSub": "Complete the remaining details to create your account",
  "auth.social.googleConnected": "Your Google account is verified",
  "auth.social.appleConnected": "Your Apple account is verified",
  "auth.social.linkSuccess": "The sign-in method was securely linked to your account.",
  "auth.social.error.existingAccount": "An account already exists with this email. Sign in with your email and password first, then link your social account from Settings > Privacy.",
  "auth.social.error.identityInUse": "This social account is linked to another Family Planner account.",
  "auth.social.error.verifyFailed": "The social account could not be verified. Please try again.",
  "auth.social.error.appleDeleteRetry": "Your Apple account could not be reauthenticated. Your account was not deleted; please try again.",
  "auth.social.error.noLinkedProvider": "No linked social sign-in method was found for account deletion.",
  "auth.social.error.generic": "Social sign-in could not be completed. Please try again.",
  "auth.social.error.googleNoCredential": "A Google account could not be selected. Make sure Google Play services are up to date and a Google account is active on this device, then try again.",
  "auth.social.error.googleProviderUnavailable": "Google sign-in could not be prepared on this device. Open Google Play once, return to the app, and try again.",
  "auth.social.error.googlePlayServices": "Update Google Play services to continue with Google, then try again.",
  "auth.social.error.googleConfiguration": "Google sign-in is currently unavailable. Make sure the app is up to date and try again.",
  "auth.social.error.network": "Google sign-in could not be completed. Check your internet connection and try again.",
  "auth.social.error.busy": "A Google sign-in screen is already open. Complete the current action or try again in a few seconds.",
  "auth.social.error.timeout": "Google sign-in took longer than expected. Please try again.",
  "settings.privacy.loginMethods": "Sign-in Methods",
  "settings.privacy.loginMethodsHint": "Securely link Google or Apple sign-in to your account.",
  "settings.privacy.connected": "Connected",
  "settings.privacy.connect": "Connect",
  "settings.privacy.socialDeleteHint": "You will reauthenticate with your linked social account before deleting your account.",
  "settings.privacy.socialReauth": "Verify Social Account and Delete",
  "profile.createPassword": "Create Password",
  "profile.createPasswordHint": "You can create a password to use email and password sign-in in addition to social sign-in.",
  "profile.passwordCreatedOk": "Password created ✓",

  /* ── Voice call (PHASE 1) ── */
  "call.start": "Start voice call",
  "call.voiceCall": "Voice call",
  "call.incoming": "is calling you",
  "call.ongoing": "Ongoing voice call",
  "call.calling": "Calling…",
  "call.someone": "Unknown",
  "call.accept": "Answer",
  "call.join": "Join",
  "call.decline": "Decline",
  "call.leave": "Leave",
  "call.mute": "Mute",
  "call.unmute": "Unmute",
  "call.declined": "Call declined.",
  "call.micDenied": "Microphone access is required for voice calls. You can allow it in Settings.",
  "call.unsupported": "This device does not support voice calls.",
  "call.startFailed": "Could not start the call. Please try again.",
  "call.joinFailed": "Could not join the call. Please try again.",
  "call.premiumTitle": "Voice chat",
  "call.premiumB1": "Talk with your family members",
  "call.premiumB2": "Group calls with up to 6 people",
  "call.premiumB3": "End-to-end encrypted, never recorded",
  "call.premiumNote": "Premium is required to start a call. You can join calls you receive without premium.",

  /* ── Voice call (PHASE 2) ── */
  "call.incomingGroup": "Group call",
  "call.people": "people",
  "call.speaking": "is speaking",
  "call.you": "You",
  "call.connecting": "Connecting…",
  "call.minimize": "Minimize",
  "call.full": "Call is full (max 6 people).",
  "call.sec": "sec",
  "call.min": "min",
  "call.logMissed": "Missed voice call",
  "call.logDeclined": "Call declined",
  "call.logCancelled": "Call cancelled",

  /* ── Voice call (PHASE 3) ── */
  "call.fullShort": "Full",
  "call.qualityFair": "Fair connection",
  "call.qualityWeak": "Weak connection",
  "call.reconnecting": "Reconnecting…",

  /* ── Poll + Read receipts (package 1 — dropped by mistake in PHASE 1) ── */
  "chat.poll": "Poll",
  "chat.pollCreate": "Create Poll",
  "chat.pollQuestion": "Question",
  "chat.pollQuestionPlaceholder": "e.g. What should we have for dinner?",
  "chat.pollOptions": "Options",
  "chat.pollOptionPlaceholder": "Option {{index}}",
  "chat.pollAddOption": "Add option",
  "chat.pollMultiSetting": "Allow multiple answers",
  "chat.pollAnonymousSetting": "Keep voters anonymous",
  "chat.pollSend": "Start Poll",
  "chat.pollMulti": "Multiple choice",
  "chat.pollAnonymous": "Anonymous",
  "chat.pollClosed": "Closed",
  "chat.pollNoVotes": "No votes yet",
  "chat.pollVoterCount": "{{count}} voted",
  "chat.pollEnd": "End poll",
  "chat.pollChangeHint": "Tap again to change",
  "chat.readByTitle": "Read by",
  "chat.readByUnknown": "Member",


  /* ── Secure family invitation ── */
  "familyInvite.title": "Secure Family Invite",
  "familyInvite.subtitle": "Create a one-time invite valid for 1 hour.",
  "familyInvite.secure": "Secure",
  "familyInvite.codeLabel": "Invite code",
  "familyInvite.maskHint": "The code is shown only when it is created.",
  "familyInvite.activeWithTime": "Active invite · {{time}}",
  "familyInvite.singleUseAndTime": "One-time use · {{time}}",
  "familyInvite.minutesLeft": "{{minutes}} minutes left",
  "familyInvite.secondsLeft": "{{seconds}} seconds left",
  "familyInvite.minutesSecondsLeft": "{{minutes}}m {{seconds}}s left",
  "familyInvite.generate": "Create Invite Code",
  "familyInvite.generateNew": "Create New Code",
  "familyInvite.generating": "Creating code…",
  "familyInvite.newCode": "New invite code",
  "familyInvite.replaceConfirm": "Creating a new code will immediately invalidate the current active invite. Continue?",
  "familyInvite.revoke": "Revoke Invite",
  "familyInvite.revokeConfirm": "Revoke the active invite code? This code can no longer be used.",
  "familyInvite.copy": "Copy",
  "familyInvite.copied": "Copied",
  "familyInvite.share": "Share",
  "familyInvite.shareTitle": "{{familyName}} Family Invite",
  "familyInvite.shareText": "👨‍👩‍👧 I’m inviting you to my family.\n\nUse the one-time invite code below to join the {{familyName}} family in Family Planner:\n\n{{code}}\n\nThis code can be used by only 1 person and is valid for 1 hour.\n\n{{appUrl}}",
  "familyInvite.shareCopied": "Invite details copied to the clipboard.",
  "familyInvite.notRecoverable": "For security, the active code cannot be shown again. Creating a new code will revoke the current one.",
  "familyInvite.educationTitle": "Secure Invite",
  "familyInvite.educationText": "This code can be used by only one person and expires automatically after 1 hour. Creating a new invite revokes the current one.",
  "familyInvite.joinTitle": "Have an Invite Code?",
  "familyInvite.joinDescription": "Enter the one-time invite code created by your family admin.",
  "familyInvite.joinHelper": "The code starts with FP-, can be used once, and is valid for 1 hour.",
  "familyInvite.errors.invalid": "The invite code is invalid. Check the code and try again.",
  "familyInvite.errors.generic": "The invite operation could not be completed. Please try again.",
  "familySwitcher.secureInvite": "Create Secure Invite",
  "familySwitcher.secureInviteSub": "One-time use · Valid for 1 hour",
  "familySwitcher.adminOnlyInvite": "Only family admins can create invites",
  "familySwitcher.secureInviteIntro": "Create a secure invite for a new family member. If an invite is already active, creating a new code revokes it automatically.",

  /* ── Apple Health / HealthKit (iOS only) ── */
  "health.apple.title": "Apple Health Summary",
  "health.apple.privateOnDevice": "Private · On this device only",
  "health.apple.sourceToday": "Apple Health · Today",
  "health.apple.todaySummary": "Today's Apple Health summary",
  "health.apple.steps": "Steps",
  "health.apple.energy": "Energy",
  "health.apple.distance": "Distance",
  "health.apple.exercise": "Exercise",
  "health.apple.sleep": "Sleep",
  "health.apple.restingHeartRate": "Resting heart rate",
  "health.apple.latestHeartRate": "Latest heart rate",
  "health.apple.heartData": "Heart rate",
  "health.apple.minuteUnit": "min",
  "health.apple.hourUnit": "hr",
  "health.apple.bpmUnit": "BPM",
  "health.apple.connect": "Connect",
  "health.apple.live": "Live",
  "health.apple.openSummary": "Open Apple Health summary",
  "health.apple.permissionEyebrow": "Your privacy, your control",
  "health.apple.permissionTitle": "See your daily health in one place",
  "health.apple.permissionDesc": "Read-only access to the Apple Health data you select is requested to show steps, active energy, walking distance, exercise, sleep, and heart rate summaries.",
  "health.apple.permissionPrivacy": "Your data is not sent to a server, shared with family members, or written back to Apple Health.",
  "health.apple.continue": "Connect Apple Health",
  "health.apple.connecting": "Connecting…",
  "health.apple.notNow": "Not Now",
  "health.apple.today": "TODAY",
  "health.apple.dailyMovement": "Your daily movement",
  "health.apple.refresh": "Refresh Apple Health data",
  "health.apple.noDataTitle": "No data to display yet",
  "health.apple.noDataDesc": "No data was found or access to this data is off. You can manage permissions in Settings.",
  "health.apple.loadFailed": "Apple Health data couldn't be refreshed right now. Please try again.",
  "health.apple.weeklyTrends": "7-day trends",
  "health.apple.weeklyTrendsDesc": "Follow changes in your movement habits",
  "health.apple.last7Days": "Last 7 days",
  "health.apple.onDeviceTitle": "On your device and private",
  "health.apple.onDeviceDesc": "Apple Health data is processed only for this screen and is never sent to a server or family members.",
  "health.apple.permissionsTitle": "Permissions stay in your control",
  "health.apple.permissionsDesc": "You can change which data types are shared at any time from iPhone Settings.",
  "health.apple.openSettings": "Manage Health Permissions",
  "health.apple.updated": "Last updated:",
  "health.apple.updatedUnknown": "Not updated yet",
  "health.apple.disclaimer": "This information is for general awareness and is not medical diagnosis or treatment advice.",
  "health.apple.unavailableTitle": "Apple Health isn't available on this device",
  "health.apple.unavailableDesc": "This feature is available on an iPhone with HealthKit support.",

  /* ── Voice call (PHASE 4 fixes) ── */
  "call.speaker": "Speaker",
  "call.earpiece": "Earpiece",
  "call.open": "Open",
  "finance.recurring.toggle": "Recurring income / expense",
  "finance.recurring.hint": "The record is created automatically at the selected interval.",
  "finance.recurring.frequency": "Repeat interval",
  "finance.recurring.monthly": "Every month",
  "finance.recurring.quarterly": "Every 3 months",
  "finance.recurring.semiannual": "Every 6 months",
  "finance.recurring.yearly": "Every year",
  "finance.recurring.endDate": "End date (optional)",
  "finance.recurring.deleteConfirm": "Do you want to delete this finance record?",
  "finance.recurring.deleteFutureQuestion": "Do you also want to stop future occurrences of this recurring record?",
  "finance.recurring.thisAndFuture": "This and future",
  "finance.recurring.onlyThis": "Only this record",
  "finance.currency.rateUnavailable": "Waiting for a current exchange rate",
  "mgmt.finance.customRule": "New payment reminder",
  "mgmt.finance.deliverySpread": "Delivery spread window (min)",
  "mgmt.finance.recordType": "Finance record type",
  "mgmt.finance.inactivityDays": "Inactivity threshold (days)",
  "mgmt.finance.repeatEveryDays": "Repeat interval (days)",
  "mgmt.finance.maxRepeat": "Maximum repeats",
  "mgmt.finance.addReminderDay": "Add payment-day rule",
};
export default en;
